import * as  React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import * as _ from 'lodash';
import * as actions from '../../../../../redux/projects/actions.projects';
import asyncDispatch from '../../../../../services/mini/asyncDispatch';
import { IProject } from '../../../../../models/IProject';
import ToasterService from '../../../../../services/ToasterService';
import ReactTooltip from 'react-tooltip';
import { ICohort } from '../../../../../models/ICohort';
import { getBoolOption, getStringOption } from '../../getProjectOptions';
import { getProjectOptionsByEnvironment } from '../../../../../services/mini/getProjectOptionsByEnvironment';
import { TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LOADER_ICON_DEFAULT_FILL_COLOR_KEY, TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LOADER_ICON_HOVER_FILL_COLOR_KEY, TEXT_CHAT_ENABLED_KEY, TEXT_CHAT_HEADER_BACKGROUND_COLOR_KEY, TEXT_CHAT_HEADER_FONT_COLOR_KEY, TEXT_CHAT_TEXTAREA_PLACEHOLDER_KEY, TEXT_CHAT_HEADER_LABEL_KEY, TEXT_CHAT_POPUP_BACKGROUND_COLOR_KEY, TEXT_CHAT_POPUP_OPEN_BY_DEFAULT_KEY, TEXT_CHAT_POPUP_CLEAR_CHAT_ON_CLOSE_KEY, TEXT_CHAT_VOICE_ENABLED_KEY, TEXT_CHAT_BUBBLES_REQUEST_BACKGROUND_COLOR_KEY, TEXT_CHAT_BUBBLES_RESPONSE_BACKGROUND_COLOR_KEY, TEXT_CHAT_BUBBLES_REQUEST_FONT_COLOR_KEY, TEXT_CHAT_BUBBLES_RESPONSE_FONT_COLOR_KEY, TEXT_CHAT_HEADER_FONT_SIZE_KEY, TEXT_CHAT_BUBBLES_REQUEST_BFONT_SIZE_KEY, TEXT_CHAT_BUBBLES_RESPONSE_FONT_SIZE_KEY, TEXT_CHAT_TEXTAREA_ICONS_DEFAULT_FILL_COLOR_KEY, TEXT_CHAT_TEXTAREA_ICONS_HOVER_FILL_COLOR_KEY, TEXT_CHAT_POPUP_MIN_HEIGHT_KEY, TEXT_CHAT_POPUP_HEIGHT_KEY, TEXT_CHAT_POPUP_MAX_HEIGHT_KEY, TEXT_CHAT_NOTIFICATIONS_BUBBLE_FONT_COLOR_KEY, TEXT_CHAT_NOTIFICATIONS_BUBBLE_BACKGROUND_COLOR_KEY, TEXT_CHAT_NOTIFICATIONS_BUBBLE_ENABLED_KEY, TEXT_CHAT_TEXTAREA_FONT_SIZE_KEY, TEXT_CHAT_POPUP_MIN_WIDTH_KEY, TEXT_CHAT_POPUP_WIDTH_KEY, TEXT_CHAT_POPUP_MAX_WIDTH_KEY, TEXT_CHAT_DEFAULT_HEIGHT, TEXT_CHAT_CLOSE_ICON_FILL_COLOR_KEY, TEXT_CHAT_CLOSE_ICON_HOVER_FILL_COLOR_KEY, TEXT_CHAT_CLEAR_ICON_FILL_COLOR_KEY, TEXT_CHAT_CLEAR_ICON_HOVER_FILL_COLOR_KEY, TEXT_CHAT_MUTE_ICON_FILL_COLOR_KEY, TEXT_CHAT_MUTE_ICON_HOVER_FILL_COLOR_KEY, TEXT_CHAT_TEXTAREA_FONT_COLOR_KEY, TEXT_CHAT_TEXTAREA_BACKGROUND_COLOR_KEY, TEXT_CHAT_TEXTAREA_PLACEHOLDER_FONT_COLOR_KEY, TEXT_CHAT_POPUP_BACKGROUND2_COLOR_KEY, TEXT_CHAT_AUDIO_ENABLED_KEY, getDefaultOptionsValue, TEXT_CHAT_POPUP_FONT_FAMILY_KEY, TEXT_CHAT_BUBBLES_RESPONSE_COPY_BTN_KEY, TEXT_CHAT_POPUP_FULL_SCREEN_MODE_ENABLED_KEY, TEXT_CHAT_POPUP_MINIMIZE_MODE_ENABLED_KEY, TEXT_CHAT_EXPAND_COLLAPSE_ICON_FILL_COLOR_KEY, TEXT_CHAT_EXPAND_COLLAPSE_ICON_HOVER_FILL_COLOR_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LIKE_BTN_KEY, TEXT_CHAT_SIDE_BAR_ICON_FILL_COLOR_KEY, TEXT_CHAT_SIDE_BAR_ICON_HOVER_FILL_COLOR_KEY, TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_TOP_LEFT_KEY, TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_TOP_RIGHT_KEY, TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_BOTTOM_LEFT_KEY, TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_BOTTOM_RIGHT_KEY, TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_TOP_LEFT_KEY, TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_TOP_RIGHT_KEY, TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_BOTTOM_LEFT_KEY, TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_BOTTOM_RIGHT_KEY, TEXT_CHAT_TEXTAREA_BORDER_RADIUS_TOP_LEFT_KEY, TEXT_CHAT_TEXTAREA_BORDER_RADIUS_TOP_RIGHT_KEY, TEXT_CHAT_TEXTAREA_BORDER_RADIUS_BOTTOM_LEFT_KEY, TEXT_CHAT_TEXTAREA_BORDER_RADIUS_BOTTOM_RIGHT_KEY, TEXT_CHAT_BUBBLES_REQUEST_BORDER_COLOR_KEY, TEXT_CHAT_BUBBLES_RESPONSE_BORDER_COLOR_KEY, TEXT_CHAT_BUBBLES_RESPONSE_CODE_BACKGROUND_COLOR_KEY, TEXT_CHAT_BUBBLES_REQUEST_HAS_SHADOW_KEY, TEXT_CHAT_BUBBLES_RESPONSE_HAS_SHADOW_KEY, TEXT_CHAT_TEXTAREA_BORDER_COLOR_KEY, TEXT_CHAT_TEXTAREA_HAS_SHADOW_KEY, TEXT_CHAT_POPUP_BORDER_RADIUS_TOP_LEFT_KEY, TEXT_CHAT_POPUP_BORDER_RADIUS_TOP_RIGHT_KEY, TEXT_CHAT_POPUP_BORDER_RADIUS_BOTTOM_RIGHT_KEY, TEXT_CHAT_POPUP_BORDER_RADIUS_BOTTOM_LEFT_KEY, TEXT_CHAT_BUTTONS_BORDER_RADIUS_BOTTOM_LEFT_KEY, TEXT_CHAT_BUTTONS_BORDER_RADIUS_BOTTOM_RIGHT_KEY, TEXT_CHAT_BUTTONS_BORDER_RADIUS_TOP_RIGHT_KEY, TEXT_CHAT_BUTTONS_BORDER_RADIUS_TOP_LEFT_KEY, TEXT_CHAT_BUTTONS_HAS_SHADOW_KEY, TEXT_CHAT_BUTTONS_BORDER_COLOR_KEY, TEXT_CHAT_BUTTONS_BACKGROUND_COLOR_KEY, TEXT_CHAT_BUTTONS_FONT_COLOR_KEY, TEXT_CHAT_BUTTONS_FONT_SIZE_KEY, TEXT_CHAT_BUTTONS_BORDER_COLOR_HOVER_KEY, TEXT_CHAT_BUTTONS_HAS_SHADOW_HOVER_KEY, TEXT_CHAT_BUTTONS_BACKGROUND_COLOR_HOVER_KEY, TEXT_CHAT_BUTTONS_FONT_COLOR_HOVER_KEY, TEXT_CHAT_BUTTONS_FONT_COLOR_ACTIVE_KEY, TEXT_CHAT_BUTTONS_BACKGROUND_COLOR_ACTIVE_KEY, TEXT_CHAT_BUTTONS_BORDER_COLOR_ACTIVE_KEY, TEXT_CHAT_BUTTONS_HAS_SHADOW_ACTIVE_KEY, TEXT_CHAT_BUTTONS_ALIGNMENT_DEFAULT_KEY, TEXT_CHAT_BUTTONS_ALIGNMENT_FULL_SCREEN_KEY, TEXT_CHAT_POPUP_BORDER_COLOR_KEY, TEXT_CHAT_POPUP_HAS_BORDER_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LINK_FONT_COLOR_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LINK_HOVERED_FONT_COLOR_KEY, TEXT_CHAT_POPUP_BACKGROUND_GRADIENT_TYPE_KEY, TEXT_CHAT_HEADER_HEIGHT_KEY, TEXT_CHAT_HEADER_WITH_BOTTOM_GRADIENT_KEY, TEXT_CHAT_FOOTER_HEIGHT_KEY, TEXT_CHAT_FOOTER_WITH_TOP_GRADIENT_KEY, TEXT_CHAT_FOOTER_BACKGROUND_COLOR_KEY, TEXT_CHAT_FOOTER_PADDING_TOP_KEY, TEXT_CHAT_FOOTER_PADDING_RIGHT_KEY, TEXT_CHAT_FOOTER_PADDING_LEFT_KEY, TEXT_CHAT_FOOTER_PADDING_BOTTOM_KEY, TEXT_CHAT_BUTTONS_PADDING_TOP_KEY, TEXT_CHAT_BUTTONS_PADDING_RIGHT_KEY, TEXT_CHAT_BUTTONS_PADDING_LEFT_KEY, TEXT_CHAT_BUTTONS_PADDING_BOTTOM_KEY, TEXT_CHAT_HEADER_PADDING_TOP_KEY, TEXT_CHAT_HEADER_PADDING_RIGHT_KEY, TEXT_CHAT_HEADER_PADDING_BOTTOM_KEY, TEXT_CHAT_HEADER_PADDING_LEFT_KEY, TEXT_CHAT_BUBBLES_REQUEST_PADDING_TOP_KEY, TEXT_CHAT_BUBBLES_REQUEST_PADDING_RIGHT_KEY, TEXT_CHAT_BUBBLES_REQUEST_PADDING_BOTTOM_KEY, TEXT_CHAT_BUBBLES_REQUEST_PADDING_LEFT_KEY, TEXT_CHAT_BUBBLES_RESPONSE_PADDING_TOP_KEY, TEXT_CHAT_BUBBLES_RESPONSE_PADDING_RIGHT_KEY, TEXT_CHAT_BUBBLES_RESPONSE_PADDING_BOTTOM_KEY, TEXT_CHAT_BUBBLES_RESPONSE_PADDING_LEFT_KEY, TEXT_CHAT_POPUP_PADDING_TOP_KEY, TEXT_CHAT_POPUP_PADDING_BOTTOM_KEY, TEXT_CHAT_POPUP_PADDING_RIGHT_KEY, TEXT_CHAT_POPUP_PADDING_LEFT_KEY, TEXT_CHAT_CLOSE_ICON_KEY, TEXT_CHAT_POPUP_FULL_SCREEN_MODE_EXPAND_ICON_KEY, TEXT_CHAT_AUDIO_VISIBLE_KEY, TEXT_CHAT_POPUP_FULL_SCREEN_MODE_COLLAPSE_ICON_KEY, TEXT_CHAT_HEADER_LAYOUT_NAME_KEY, TEXT_CHAT_CLEAR_ICON_VISIBLE_KEY, TEXT_CHAT_FOOTER_LAYOUT_NAME_KEY, TEXT_CHAT_SEND_ICON_KEY, TEXT_CHAT_MIC_ICON_KEY, TEXT_CHAT_MUTE_ICON_KEY, TEXT_CHAT_UNMUTE_ICON_KEY, TEXT_CHAT_BUBBLES_REQUEST_LABEL_TEXT_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LABEL_TEXT_KEY, TEXT_CHAT_BUTTONS_TEXT_ALIGNMENT_DEFAULT_KEY, TEXT_CHAT_BUTTONS_GAP_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_BOTTOM_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_RIGHT_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_TOP_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_LEFT_KEY, TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_TOP_KEY, TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_RIGHT_KEY, TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_BOTTOM_KEY, TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_LEFT_KEY, TEXT_CHAT_BUBBLES_REQUEST_LABEL_FONT_SIZE_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LABEL_FONT_SIZE_KEY, TEXT_CHAT_BUBBLES_REQUEST_LABEL_FONT_COLOR_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LABEL_FONT_COLOR_KEY, TEXT_CHAT_BUBBLES_REQUEST_LABEL_ENABLED_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ENABLED_KEY, TEXT_CHAT_TEXTAREA_PADDING_TOP_KEY, TEXT_CHAT_TEXTAREA_PADDING_RIGHT_KEY, TEXT_CHAT_TEXTAREA_PADDING_BOTTOM_KEY, TEXT_CHAT_TEXTAREA_PADDING_LEFT_KEY, TEXT_CHAT_LEAR_MORE_LINKS_ACTIVE_BORDER_COLOR_KEY, TEXT_CHAT_LEAR_MORE_LINKS_HOVER_BORDER_COLOR_KEY, TEXT_CHAT_LEAR_MORE_LINKS_DEFAULT_BORDER_COLOR_KEY, TEXT_CHAT_LEAR_MORE_LINKS_LINK_NUMBER_DEFAULT_BACKGROUND_COLOR_KEY, TEXT_CHAT_LEAR_MORE_LINKS_LINK_NUMBER_HOVER_BACKGROUND_COLOR_KEY, TEXT_CHAT_LEAR_MORE_LINKS_LINK_NUMBER_ACTIVE_BACKGROUND_COLOR_KEY, TEXT_CHAT_LEAR_MORE_LINKS_LINK_DEFAULT_BACKGROUND_COLOR_KEY, TEXT_CHAT_LEAR_MORE_LINKS_LINK_HOVER_BACKGROUND_COLOR_KEY, TEXT_CHAT_LEAR_MORE_LINKS_LINK_ACTIVE_BACKGROUND_COLOR_KEY, TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_TOP_LEFT_KEY, TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_TOP_RIGHT_KEY, TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_BOTTOM_LEFT_KEY, TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_BOTTOM_RIGHT_KEY, TEXT_CHAT_TEXTAREA_FIELD_TYPE_KEY, TEXT_CHAT_HEADER_LABEL_ICON_KEY, TEXT_CHAT_HEADER_LABEL_ICON_GAP_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ICON_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ICON_GAP_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ALIGNMENT_KEY, TEXT_CHAT_HEADER_LABEL_ALIGNMENT_KEY, TEXT_CHAT_TEXTAREA_MAX_LINES_COUNT_KEY, TEXT_CHAT_POPUP_BACKGROUND_CUSTOM_KEY, TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LAYOUT_KEY, TEXT_CHAT_BUBBLES_NEW_DIALOG_SEPARATOR_COLOR_KEY, TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LABEL_KEY, TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LOADER_ICON_KEY, TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LABEL_ICON_GAP_KEY, TEXT_CHAT_BUBBLES_WAITING_RESPONSE_ALIGNMENT_KEY, TEXT_CHAT_BUBBLES_RESPONSE_TABLE_BORDER_COLOR_KEY, TEXT_CHAT_BUBBLES_RESPONSE_CODE_BORDER_COLOR_KEY, TEXT_CHAT_BUBBLES_RESPONSE_CODE_THEME_KEY, TEXT_CHAT_POPUP_SAVE_CHAT_STATE_ENABLED_KEY, TEXT_CHAT_SAVE_TEXT_CHAT_STATE_ICON_FILL_COLOR_KEY, TEXT_CHAT_SAVE_TEXT_CHAT_STATE_ICON_HOVER_FILL_COLOR_KEY, TEXT_CHAT_SAVE_CHAT_STATE_ICON_KEY, TEXT_CHAT_BUBBLES_RESPONSE_BOTTOM_BTNS_COLOR_KEY, TEXT_CHAT_BUBBLES_RESPONSE_BOTTOM_BTNS_BACKGROUND_HOVERED_KEY, TEXT_CHAT_BUBBLES_WAITING_RESPONSE_QUERY_PROGRESS_ENABLED_KEY, TEXT_CHAT_MINIMIZE_ICON_FILL_COLOR_KEY, TEXT_CHAT_MINIMIZE_ICON_HOVER_FILL_COLOR_KEY, TEXT_CHAT_MINIMIZE_ICON_KEY } from '../../defaultProjectOptions';
import { IStore } from '../../../../../redux/initialState';
import { Environment } from '../../../../../const/environment';
import { ColorPickerHorizontalPosition, ColorPickerVerticalPosition } from '../../../../components/ColorPicker/ColorPicker';
import { TextChatPreview } from '../TextChatPreview/TextChatPreview';
import { toogleBooleanOption } from '../../../../../services/mini/toogleBooleanOption';
import { NotificationsBtnPreview } from '../NotificationsBtnPreview/NotificationsBtnPreview';
import menuItems from '../../../../../const/menuItems';
import AutoComplete from '../../../../components/AutoComplete/AutoComplete';
import { webSafeFonts } from '../../../../../const/webSafeFonts';
import copyTextToBuffer from '../../../../../services/mini/copyTextToBuffer';
import { ComboBoxOption } from '../../common/ComboBoxOption';
import { SwitcherOption } from '../../common/SwitcherOption';
import { ColorPickerOption } from '../../common/ColorPickerOption';
import { InputOption } from '../../common/InputOption';
import { SvgIconOption } from '../../common/SvgIconOption';
import isLocalStorageAvailable from '../../../../../services/mini/isLocalStorageAvailable';
import { fillTextChatOptionState } from './fillTextChatOptionState';

const alignOptions = [
    { key: 'left', name: 'Left' },
    { key: 'center', name: 'Center' },
    { key: 'right', name: 'Right' },
];

const gradientTypes = [
    { key: 'linear', name: 'Linear' },
    { key: 'radial', name: 'Radial' },
    { key: 'custom', name: 'Custom' },
];

const verticalAlignments = [
    { key: 'flex-start', name: 'Top' },
    { key: 'center', name: 'Center' },
    { key: 'flex-end', name: 'Bottom' },
];

const codeThemes = [
    { key: 'light', name: 'Light' },
    { key: 'dark', name: 'Dark' },
];

const headerLayoutTypes = [
    { key: 'centered-title', name: 'Title in the center' },
    { key: 'left-title', name: 'Title on the left' },
];

const chatInputTypes = [
    { key: 'single-line', name: 'Single line' },
    { key: 'multi-line', name: 'Multi line' },
];

const footerLayoutTypes = [
    { key: 'default', name: 'Default' },
    { key: 'send-btn-outside', name: 'Send button outside' },
];

const waitingResponseLayoutTypes = [
    { key: 'default', name: 'Default' },
    { key: 'loader-and-label-wo-bubble', name: 'Loader + label, without background' },
];

enum TextChatPreviewModeOptions {
    Chat = 'chat',
    Btn = 'btn',
}

type TextChatOptionsProps = PropsFromRedux & {
    projectId: string
    project: IProject
    environment: Environment
    platform: string
    selectedCohortId: string
    cohorts: ICohort[]
    onOptionsChange: (newOptions: object) => void;
    currentOptions: object
};


export type TextChatBtnOptionsState = {
    [TEXT_CHAT_ENABLED_KEY]: boolean,
    [TEXT_CHAT_POPUP_OPEN_BY_DEFAULT_KEY]: boolean,
    [TEXT_CHAT_POPUP_CLEAR_CHAT_ON_CLOSE_KEY]: boolean,
    [TEXT_CHAT_POPUP_FULL_SCREEN_MODE_ENABLED_KEY]: boolean,
    [TEXT_CHAT_POPUP_MINIMIZE_MODE_ENABLED_KEY]: boolean,
    [TEXT_CHAT_POPUP_SAVE_CHAT_STATE_ENABLED_KEY]: boolean,
    [TEXT_CHAT_VOICE_ENABLED_KEY]: boolean,
    [TEXT_CHAT_AUDIO_ENABLED_KEY]: boolean,
    [TEXT_CHAT_AUDIO_VISIBLE_KEY]: boolean,
    [TEXT_CHAT_CLEAR_ICON_VISIBLE_KEY]: boolean,
    [TEXT_CHAT_HEADER_LABEL_KEY]: string,
    [TEXT_CHAT_HEADER_FONT_COLOR_KEY]: string,
    [TEXT_CHAT_HEADER_BACKGROUND_COLOR_KEY]: string,
    [TEXT_CHAT_HEADER_HEIGHT_KEY]: string,
    [TEXT_CHAT_HEADER_WITH_BOTTOM_GRADIENT_KEY]: boolean,

    [TEXT_CHAT_HEADER_PADDING_TOP_KEY]: string,
    [TEXT_CHAT_HEADER_PADDING_RIGHT_KEY]: string,
    [TEXT_CHAT_HEADER_PADDING_BOTTOM_KEY]: string,
    [TEXT_CHAT_HEADER_PADDING_LEFT_KEY]: string,

    [TEXT_CHAT_TEXTAREA_PADDING_TOP_KEY]: string,
    [TEXT_CHAT_TEXTAREA_PADDING_RIGHT_KEY]: string,
    [TEXT_CHAT_TEXTAREA_PADDING_BOTTOM_KEY]: string,
    [TEXT_CHAT_TEXTAREA_PADDING_LEFT_KEY]: string,

    [TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LAYOUT_KEY]: string,
    [TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LABEL_KEY]: string,
    [TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LOADER_ICON_KEY]: string,
    [TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LABEL_ICON_GAP_KEY]: string,
    [TEXT_CHAT_BUBBLES_WAITING_RESPONSE_ALIGNMENT_KEY]: string,

    [TEXT_CHAT_BUBBLES_NEW_DIALOG_SEPARATOR_COLOR_KEY]: string,


    [TEXT_CHAT_TEXTAREA_FIELD_TYPE_KEY]: string,
    [TEXT_CHAT_TEXTAREA_MAX_LINES_COUNT_KEY]: string,

    [TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_TOP_LEFT_KEY]: string,
    [TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_TOP_RIGHT_KEY]: string,
    [TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_BOTTOM_LEFT_KEY]: string,
    [TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_BOTTOM_RIGHT_KEY]: string,

    [TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_TOP_KEY]: string,
    [TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_RIGHT_KEY]: string,
    [TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_BOTTOM_KEY]: string,
    [TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_LEFT_KEY]: string,
    [TEXT_CHAT_BUBBLES_REQUEST_LABEL_FONT_SIZE_KEY]: string,
    [TEXT_CHAT_BUBBLES_REQUEST_LABEL_FONT_COLOR_KEY]: string,
    [TEXT_CHAT_BUBBLES_REQUEST_LABEL_ENABLED_KEY]: boolean,

    [TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_TOP_KEY]: string,
    [TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_RIGHT_KEY]: string,
    [TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_BOTTOM_KEY]: string,
    [TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_LEFT_KEY]: string,
    [TEXT_CHAT_BUBBLES_RESPONSE_LABEL_FONT_SIZE_KEY]: string,
    [TEXT_CHAT_BUBBLES_RESPONSE_LABEL_FONT_COLOR_KEY]: string,

    [TEXT_CHAT_BUBBLES_RESPONSE_BOTTOM_BTNS_COLOR_KEY]: string,
    [TEXT_CHAT_BUBBLES_RESPONSE_BOTTOM_BTNS_BACKGROUND_HOVERED_KEY]: string,

    [TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ENABLED_KEY]: boolean,

    [TEXT_CHAT_BUBBLES_REQUEST_PADDING_TOP_KEY]: string,
    [TEXT_CHAT_BUBBLES_REQUEST_PADDING_RIGHT_KEY]: string,
    [TEXT_CHAT_BUBBLES_REQUEST_PADDING_BOTTOM_KEY]: string,
    [TEXT_CHAT_BUBBLES_REQUEST_PADDING_LEFT_KEY]: string,

    [TEXT_CHAT_BUBBLES_RESPONSE_PADDING_TOP_KEY]: string,
    [TEXT_CHAT_BUBBLES_RESPONSE_PADDING_RIGHT_KEY]: string,
    [TEXT_CHAT_BUBBLES_RESPONSE_PADDING_BOTTOM_KEY]: string,
    [TEXT_CHAT_BUBBLES_RESPONSE_PADDING_LEFT_KEY]: string,


    [TEXT_CHAT_FOOTER_HEIGHT_KEY]: string,
    [TEXT_CHAT_FOOTER_WITH_TOP_GRADIENT_KEY]: boolean,
    [TEXT_CHAT_FOOTER_BACKGROUND_COLOR_KEY]: string,

    [TEXT_CHAT_FOOTER_PADDING_TOP_KEY]: string,
    [TEXT_CHAT_FOOTER_PADDING_RIGHT_KEY]: string,
    [TEXT_CHAT_FOOTER_PADDING_BOTTOM_KEY]: string,
    [TEXT_CHAT_FOOTER_PADDING_LEFT_KEY]: string,

    [TEXT_CHAT_HEADER_LAYOUT_NAME_KEY]: string,
    [TEXT_CHAT_FOOTER_LAYOUT_NAME_KEY]: string,

    [TEXT_CHAT_POPUP_BACKGROUND_GRADIENT_TYPE_KEY]: string,
    [TEXT_CHAT_POPUP_BACKGROUND_CUSTOM_KEY]: string,
    [TEXT_CHAT_POPUP_BACKGROUND_COLOR_KEY]: string,
    [TEXT_CHAT_POPUP_BACKGROUND2_COLOR_KEY]: string,
    [TEXT_CHAT_POPUP_BORDER_COLOR_KEY]: string,
    [TEXT_CHAT_POPUP_HAS_BORDER_KEY]: boolean,
    [TEXT_CHAT_BUBBLES_REQUEST_BACKGROUND_COLOR_KEY]: string,
    [TEXT_CHAT_BUBBLES_RESPONSE_BACKGROUND_COLOR_KEY]: string,
    [TEXT_CHAT_BUBBLES_REQUEST_FONT_COLOR_KEY]: string,
    [TEXT_CHAT_BUBBLES_RESPONSE_FONT_COLOR_KEY]: string,
    [TEXT_CHAT_HEADER_FONT_SIZE_KEY]: string,
    [TEXT_CHAT_BUBBLES_REQUEST_BFONT_SIZE_KEY]: string,
    [TEXT_CHAT_BUBBLES_RESPONSE_FONT_SIZE_KEY]: string,
    [TEXT_CHAT_TEXTAREA_FONT_SIZE_KEY]: string,
    [TEXT_CHAT_TEXTAREA_PLACEHOLDER_KEY]: string,
    [TEXT_CHAT_TEXTAREA_FONT_COLOR_KEY]: string,
    [TEXT_CHAT_TEXTAREA_PLACEHOLDER_FONT_COLOR_KEY]: string,
    [TEXT_CHAT_TEXTAREA_BACKGROUND_COLOR_KEY]: string,
    [TEXT_CHAT_TEXTAREA_ICONS_DEFAULT_FILL_COLOR_KEY]: string,
    [TEXT_CHAT_TEXTAREA_ICONS_HOVER_FILL_COLOR_KEY]: string,
    [TEXT_CHAT_SEND_ICON_KEY]: string,
    [TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LOADER_ICON_DEFAULT_FILL_COLOR_KEY]: string,
    [TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LOADER_ICON_HOVER_FILL_COLOR_KEY]: string,
    [TEXT_CHAT_MIC_ICON_KEY]: string,
    [TEXT_CHAT_CLOSE_ICON_KEY]: string,
    [TEXT_CHAT_SAVE_CHAT_STATE_ICON_KEY]: string,
    [TEXT_CHAT_MUTE_ICON_KEY]: string,
    [TEXT_CHAT_UNMUTE_ICON_KEY]: string,
    [TEXT_CHAT_CLOSE_ICON_FILL_COLOR_KEY]: string,
    [TEXT_CHAT_CLOSE_ICON_HOVER_FILL_COLOR_KEY]: string,
    [TEXT_CHAT_MINIMIZE_ICON_FILL_COLOR_KEY]: string,
    [TEXT_CHAT_MINIMIZE_ICON_HOVER_FILL_COLOR_KEY]: string,
    [TEXT_CHAT_MINIMIZE_ICON_KEY]: string,
    [TEXT_CHAT_CLEAR_ICON_FILL_COLOR_KEY]: string,
    [TEXT_CHAT_CLEAR_ICON_HOVER_FILL_COLOR_KEY]: string,
    [TEXT_CHAT_MUTE_ICON_FILL_COLOR_KEY]: string,
    [TEXT_CHAT_MUTE_ICON_HOVER_FILL_COLOR_KEY]: string,
    [TEXT_CHAT_EXPAND_COLLAPSE_ICON_FILL_COLOR_KEY]: string,
    [TEXT_CHAT_EXPAND_COLLAPSE_ICON_HOVER_FILL_COLOR_KEY]: string,
    [TEXT_CHAT_SAVE_TEXT_CHAT_STATE_ICON_FILL_COLOR_KEY]: string,
    [TEXT_CHAT_SAVE_TEXT_CHAT_STATE_ICON_HOVER_FILL_COLOR_KEY]: string,
    [TEXT_CHAT_POPUP_FULL_SCREEN_MODE_COLLAPSE_ICON_KEY]: string,
    [TEXT_CHAT_POPUP_FULL_SCREEN_MODE_EXPAND_ICON_KEY]: string,
    [TEXT_CHAT_SIDE_BAR_ICON_FILL_COLOR_KEY]: string,
    [TEXT_CHAT_SIDE_BAR_ICON_HOVER_FILL_COLOR_KEY]: string,
    [TEXT_CHAT_POPUP_MIN_HEIGHT_KEY]: string,
    [TEXT_CHAT_POPUP_HEIGHT_KEY]: string,
    [TEXT_CHAT_POPUP_MAX_HEIGHT_KEY]: string,
    [TEXT_CHAT_POPUP_MIN_WIDTH_KEY]: string,
    [TEXT_CHAT_POPUP_WIDTH_KEY]: string,
    [TEXT_CHAT_POPUP_MAX_WIDTH_KEY]: string,
    [TEXT_CHAT_POPUP_FONT_FAMILY_KEY]: string,
    [TEXT_CHAT_POPUP_PADDING_TOP_KEY]: string,
    [TEXT_CHAT_POPUP_PADDING_RIGHT_KEY]: string,
    [TEXT_CHAT_POPUP_PADDING_BOTTOM_KEY]: string,
    [TEXT_CHAT_POPUP_PADDING_LEFT_KEY]: string,
    [TEXT_CHAT_NOTIFICATIONS_BUBBLE_FONT_COLOR_KEY]: string,
    [TEXT_CHAT_NOTIFICATIONS_BUBBLE_BACKGROUND_COLOR_KEY]: string,
    [TEXT_CHAT_NOTIFICATIONS_BUBBLE_ENABLED_KEY]: boolean,
    [TEXT_CHAT_BUBBLES_RESPONSE_COPY_BTN_KEY]: boolean,
    [TEXT_CHAT_BUBBLES_RESPONSE_LIKE_BTN_KEY]: boolean,
    [TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_TOP_LEFT_KEY]: string,
    [TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_TOP_RIGHT_KEY]: string,
    [TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_BOTTOM_LEFT_KEY]: string,
    [TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_BOTTOM_RIGHT_KEY]: string,
    [TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_TOP_LEFT_KEY]: string,
    [TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_TOP_RIGHT_KEY]: string,
    [TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_BOTTOM_LEFT_KEY]: string,
    [TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_BOTTOM_RIGHT_KEY]: string,
    [TEXT_CHAT_BUBBLES_RESPONSE_LINK_FONT_COLOR_KEY]: string,
    [TEXT_CHAT_BUBBLES_RESPONSE_LINK_HOVERED_FONT_COLOR_KEY]: string,
    [TEXT_CHAT_TEXTAREA_BORDER_RADIUS_TOP_LEFT_KEY]: string,
    [TEXT_CHAT_TEXTAREA_BORDER_RADIUS_TOP_RIGHT_KEY]: string,
    [TEXT_CHAT_TEXTAREA_BORDER_RADIUS_BOTTOM_LEFT_KEY]: string,
    [TEXT_CHAT_TEXTAREA_BORDER_RADIUS_BOTTOM_RIGHT_KEY]: string,
    [TEXT_CHAT_BUBBLES_REQUEST_BORDER_COLOR_KEY]: string,
    [TEXT_CHAT_BUBBLES_RESPONSE_BORDER_COLOR_KEY]: string,

    [TEXT_CHAT_BUBBLES_RESPONSE_CODE_BACKGROUND_COLOR_KEY]: string,
    [TEXT_CHAT_BUBBLES_RESPONSE_CODE_BORDER_COLOR_KEY]: string,
    [TEXT_CHAT_BUBBLES_RESPONSE_CODE_THEME_KEY]: string,


    [TEXT_CHAT_TEXTAREA_BORDER_COLOR_KEY]: string,
    [TEXT_CHAT_BUBBLES_REQUEST_HAS_SHADOW_KEY]: boolean,
    [TEXT_CHAT_BUBBLES_RESPONSE_HAS_SHADOW_KEY]: boolean,
    [TEXT_CHAT_TEXTAREA_HAS_SHADOW_KEY]: boolean,
    [TEXT_CHAT_POPUP_BORDER_RADIUS_TOP_LEFT_KEY]: string,
    [TEXT_CHAT_POPUP_BORDER_RADIUS_TOP_RIGHT_KEY]: string,
    [TEXT_CHAT_POPUP_BORDER_RADIUS_BOTTOM_LEFT_KEY]: string,
    [TEXT_CHAT_POPUP_BORDER_RADIUS_BOTTOM_RIGHT_KEY]: string,
    [TEXT_CHAT_BUTTONS_FONT_SIZE_KEY]: string,
    [TEXT_CHAT_BUTTONS_FONT_COLOR_KEY]: string,
    [TEXT_CHAT_BUTTONS_BACKGROUND_COLOR_KEY]: string,
    [TEXT_CHAT_BUTTONS_BORDER_RADIUS_TOP_LEFT_KEY]: string,
    [TEXT_CHAT_BUTTONS_BORDER_RADIUS_TOP_RIGHT_KEY]: string,
    [TEXT_CHAT_BUTTONS_BORDER_RADIUS_BOTTOM_LEFT_KEY]: string,
    [TEXT_CHAT_BUTTONS_BORDER_RADIUS_BOTTOM_RIGHT_KEY]: string,
    [TEXT_CHAT_BUTTONS_GAP_KEY]: string,
    [TEXT_CHAT_BUTTONS_BORDER_COLOR_KEY]: string,
    [TEXT_CHAT_BUTTONS_HAS_SHADOW_KEY]: boolean,
    [TEXT_CHAT_BUTTONS_FONT_COLOR_HOVER_KEY]: string,
    [TEXT_CHAT_BUTTONS_BACKGROUND_COLOR_HOVER_KEY]: string,
    [TEXT_CHAT_BUTTONS_BORDER_COLOR_HOVER_KEY]: string,
    [TEXT_CHAT_BUTTONS_HAS_SHADOW_HOVER_KEY]: boolean,
    [TEXT_CHAT_BUTTONS_FONT_COLOR_ACTIVE_KEY]: string,
    [TEXT_CHAT_BUTTONS_BACKGROUND_COLOR_ACTIVE_KEY]: string,
    [TEXT_CHAT_BUTTONS_BORDER_COLOR_ACTIVE_KEY]: string,
    [TEXT_CHAT_BUTTONS_HAS_SHADOW_ACTIVE_KEY]: boolean,
    [TEXT_CHAT_BUBBLES_WAITING_RESPONSE_QUERY_PROGRESS_ENABLED_KEY]: boolean,
    [TEXT_CHAT_BUTTONS_ALIGNMENT_DEFAULT_KEY]: string,
    [TEXT_CHAT_BUTTONS_TEXT_ALIGNMENT_DEFAULT_KEY]: string,
    [TEXT_CHAT_BUTTONS_ALIGNMENT_FULL_SCREEN_KEY]: string,
    [TEXT_CHAT_BUTTONS_PADDING_TOP_KEY]: string,
    [TEXT_CHAT_BUTTONS_PADDING_RIGHT_KEY]: string,
    [TEXT_CHAT_BUTTONS_PADDING_BOTTOM_KEY]: string,
    [TEXT_CHAT_BUTTONS_PADDING_LEFT_KEY]: string,
    [TEXT_CHAT_BUBBLES_REQUEST_LABEL_TEXT_KEY]: string,
    [TEXT_CHAT_BUBBLES_RESPONSE_LABEL_TEXT_KEY]: string,
    [TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ICON_KEY]: string,
    [TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ICON_GAP_KEY]: string,
    [TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ALIGNMENT_KEY]: string,

    [TEXT_CHAT_LEAR_MORE_LINKS_DEFAULT_BORDER_COLOR_KEY]: string,
    [TEXT_CHAT_LEAR_MORE_LINKS_HOVER_BORDER_COLOR_KEY]: string,
    [TEXT_CHAT_LEAR_MORE_LINKS_ACTIVE_BORDER_COLOR_KEY]: string,


    [TEXT_CHAT_LEAR_MORE_LINKS_LINK_NUMBER_DEFAULT_BACKGROUND_COLOR_KEY]: string,
    [TEXT_CHAT_LEAR_MORE_LINKS_LINK_NUMBER_HOVER_BACKGROUND_COLOR_KEY]: string,
    [TEXT_CHAT_LEAR_MORE_LINKS_LINK_NUMBER_ACTIVE_BACKGROUND_COLOR_KEY]: string,

    [TEXT_CHAT_BUBBLES_RESPONSE_TABLE_BORDER_COLOR_KEY]: string,

    [TEXT_CHAT_LEAR_MORE_LINKS_LINK_DEFAULT_BACKGROUND_COLOR_KEY]: string,
    [TEXT_CHAT_LEAR_MORE_LINKS_LINK_HOVER_BACKGROUND_COLOR_KEY]: string,
    [TEXT_CHAT_LEAR_MORE_LINKS_LINK_ACTIVE_BACKGROUND_COLOR_KEY]: string,

    [TEXT_CHAT_HEADER_LABEL_ICON_KEY]: string,
    [TEXT_CHAT_HEADER_LABEL_ICON_GAP_KEY]: string,
    [TEXT_CHAT_HEADER_LABEL_ALIGNMENT_KEY]: string,


}

type TextChatOptionsState = TextChatBtnOptionsState & {
    previewMode: TextChatPreviewModeOptions
    fontFamilyUpdateTs: number,
    updateTs: number,
}

class TextChatOptions extends React.Component<TextChatOptionsProps, TextChatOptionsState> {

    _isMounted: boolean;
    optionsContainerRef;
    fileInput;

    constructor(props) {
        super(props);

        this.state = {
            ...this.fillState(props),
        };

        this.optionsContainerRef = React.createRef();
        this.fileInput = React.createRef();
    }


    componentDidMount() {
        this._isMounted = true;
        this.setState({ ...this.fillState(this.props) });
        this.restoreScrollPosition();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    fillState = (props) => {
        return {
            ...fillTextChatOptionState(props),
            previewMode: TextChatPreviewModeOptions.Chat,
            fontFamilyUpdateTs: 0,
            updateTs: 0,
        };
    }

    toggleBoolOption = (optionName, optionNameOld?) => {
        return toogleBooleanOption(this.props, this.state[optionName], (newVal) => {
            this.setState({ [optionName]: newVal } as TextChatOptionsState);
        }, true, optionName, optionNameOld).then((updatedOpions) => {
            if (updatedOpions) {
                this.props.onOptionsChange(updatedOpions);
            }
        });
    }

    setTextOption = (optionName, toastrMsg) => {
        const {
            project,
            platform,
            environment,
            cohorts,
            selectedCohortId,
            currentOptions
        } = this.props;

        const value = this.state[optionName];

        const options = getProjectOptionsByEnvironment(project, platform, environment, cohorts, selectedCohortId);
        options[platform] = currentOptions || {};

        if (_.get(options[platform], optionName) === value) {
            return;
        }
        if (_.get(options[platform], optionName) === undefined && value === getDefaultOptionsValue(platform, optionName)) {
            return;
        }
        options[platform] = _.set(options[platform], optionName, value);
        this.props.onOptionsChange(options[platform]);
    }

    setEnabledSettings = () => {
        this.toggleBoolOption(TEXT_CHAT_ENABLED_KEY);
    }

    setOpenByDefaultSettings = () => {
        this.toggleBoolOption(TEXT_CHAT_POPUP_OPEN_BY_DEFAULT_KEY);
    }

    setClearChatOnCloseSettings = () => {
        this.toggleBoolOption(TEXT_CHAT_POPUP_CLEAR_CHAT_ON_CLOSE_KEY);
    }

    setFullScreenModeSettings = () => {
        this.toggleBoolOption(TEXT_CHAT_POPUP_FULL_SCREEN_MODE_ENABLED_KEY);
    }

    setMinimizeModeSettings = () => {
        this.toggleBoolOption(TEXT_CHAT_POPUP_MINIMIZE_MODE_ENABLED_KEY);
    }

    setSaveTextChatHistorySettings = () => {
        this.toggleBoolOption(TEXT_CHAT_POPUP_SAVE_CHAT_STATE_ENABLED_KEY);
    }

    setVoiceEnabledSettings = () => {
        this.toggleBoolOption(TEXT_CHAT_VOICE_ENABLED_KEY);
    }

    setBorderForChatSettings = () => {
        this.toggleBoolOption(TEXT_CHAT_POPUP_HAS_BORDER_KEY);
    }

    setHeaderWithBottomGradientSettings = () => {
        this.toggleBoolOption(TEXT_CHAT_HEADER_WITH_BOTTOM_GRADIENT_KEY);
    }

    setFooterWithTopGradientSettings = () => {
        this.toggleBoolOption(TEXT_CHAT_FOOTER_WITH_TOP_GRADIENT_KEY);
    }

    setShadowForRequestSettings = () => {
        this.toggleBoolOption(TEXT_CHAT_BUBBLES_REQUEST_HAS_SHADOW_KEY);
    }

    setShadowForResponsesSettings = () => {
        this.toggleBoolOption(TEXT_CHAT_BUBBLES_RESPONSE_HAS_SHADOW_KEY);
    }

    setBubbleLabelEnabledForRequest = () => {
        this.toggleBoolOption(TEXT_CHAT_BUBBLES_REQUEST_LABEL_ENABLED_KEY);
    }

    setBubbleLabelEnabledForResponse = () => {
        this.toggleBoolOption(TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ENABLED_KEY);
    }

    setShadowForTextareaSettings = () => {
        this.toggleBoolOption(TEXT_CHAT_TEXTAREA_HAS_SHADOW_KEY);
    }

    setShadowForButtonsSettings = () => {
        this.toggleBoolOption(TEXT_CHAT_BUTTONS_HAS_SHADOW_KEY);
    }

    setShadowForButtonsHoverSettings = () => {
        this.toggleBoolOption(TEXT_CHAT_BUTTONS_HAS_SHADOW_HOVER_KEY);
    }

    setCopyBtnForResponsesSettings = () => {
        this.toggleBoolOption(TEXT_CHAT_BUBBLES_RESPONSE_COPY_BTN_KEY);
    }

    setLikeBtnForResponsesSettings = () => {
        this.toggleBoolOption(TEXT_CHAT_BUBBLES_RESPONSE_LIKE_BTN_KEY);
    }

    setAudioEnabledSettings = () => {
        this.toggleBoolOption(TEXT_CHAT_AUDIO_ENABLED_KEY);
    }

    setAudioVisibilitySettings = () => {
        this.toggleBoolOption(TEXT_CHAT_AUDIO_VISIBLE_KEY);
    }

    setClearIconVisibilitySettings = () => {
        this.toggleBoolOption(TEXT_CHAT_CLEAR_ICON_VISIBLE_KEY);
    }

    onSaveHeaderLabel = (label) => {
        this.setState({ [TEXT_CHAT_HEADER_LABEL_KEY]: label }, () => {
            this.setTextOption(TEXT_CHAT_HEADER_LABEL_KEY, 'Label for text chat header was saved.');
        });
    }

    onCustomBgChanged = (label) => {
        this.setState({ [TEXT_CHAT_POPUP_BACKGROUND_CUSTOM_KEY]: label }, () => {
            this.setTextOption(TEXT_CHAT_POPUP_BACKGROUND_CUSTOM_KEY, 'Background was saved.');
        });
    }

    onRequestLabelSave = (label) => {
        this.setState({ [TEXT_CHAT_BUBBLES_REQUEST_LABEL_TEXT_KEY]: label }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_REQUEST_LABEL_TEXT_KEY, 'Label for request bubble was saved.');
        });
    }

    onResponseLabelSave = (label) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_LABEL_TEXT_KEY]: label }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_LABEL_TEXT_KEY, 'Label for response bubble was saved.');
        });
    }

    onSaveFontFamily = (label) => {
        this.setState({ [TEXT_CHAT_POPUP_FONT_FAMILY_KEY]: label }, () => {
            this.setTextOption(TEXT_CHAT_POPUP_FONT_FAMILY_KEY, 'Font for text chat was saved.');
        });
    }

    onSaveTextarePlaceholder = (label) => {
        this.setState({ [TEXT_CHAT_TEXTAREA_PLACEHOLDER_KEY]: label }, () => {
            this.setTextOption(TEXT_CHAT_TEXTAREA_PLACEHOLDER_KEY, 'Placeholder was saved.');
        });
    }

    onWaitingBubbleLabelChange = (label) => {
        this.setState({ [TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LABEL_KEY]: label }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LABEL_KEY, 'Label was saved.');
        });
    }

    onHeaderFontColorChange = (color: string) => {
        this.setState({ [TEXT_CHAT_HEADER_FONT_COLOR_KEY]: color });
    }

    onHeaderFontColorClose = () => {
        this.setTextOption(TEXT_CHAT_HEADER_FONT_COLOR_KEY, 'Font color for text chat header was saved.');
    }

    onHeaderBackgroundColorChange = (color: string) => {
        this.setState({ [TEXT_CHAT_HEADER_BACKGROUND_COLOR_KEY]: color });
    }

    onHeaderBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_HEADER_BACKGROUND_COLOR_KEY, 'Background color for text chat header was saved.');
    }

    onTextChatBackgroundColorChange = (color: string) => {
        this.setState({ [TEXT_CHAT_POPUP_BACKGROUND_COLOR_KEY]: color });
    }

    onTextChatBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_POPUP_BACKGROUND_COLOR_KEY, 'Background gradient color (bottom) for text chat was saved.');
    }

    onTextChatBackground2ColorChange = (color: string) => {
        this.setState({ [TEXT_CHAT_POPUP_BACKGROUND2_COLOR_KEY]: color });
    }

    onTextChatBackground2ColorClose = () => {
        this.setTextOption(TEXT_CHAT_POPUP_BACKGROUND2_COLOR_KEY, 'Background gradient color (top) for text chat was saved.');
    }

    onRequestBubbleBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUBBLES_REQUEST_BACKGROUND_COLOR_KEY, 'Request bubble background color was saved.');
    }

    onRequestBubbleBackgroundColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUBBLES_REQUEST_BACKGROUND_COLOR_KEY]: color });
    }

    onChatBorderColorClose = () => {
        this.setTextOption(TEXT_CHAT_POPUP_BORDER_COLOR_KEY, 'Chat border color was saved.');
    }

    onChatBorderColorChange = (color) => {
        this.setState({ [TEXT_CHAT_POPUP_BORDER_COLOR_KEY]: color });
    }

    onRequestBubbleBorderColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUBBLES_REQUEST_BORDER_COLOR_KEY, 'Request bubble border color was saved.');
    }

    onRequestBubbleBorderColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUBBLES_REQUEST_BORDER_COLOR_KEY]: color });
    }

    onResponseBubbleBorderColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_BORDER_COLOR_KEY, 'Response bubble border color was saved.');
    }

    onResponseBubbleCodeBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_CODE_BACKGROUND_COLOR_KEY, 'Code background color was saved.');
    }

    onResponseBubbleCodeBorderColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_CODE_BORDER_COLOR_KEY, 'Code border color was saved.');
    }


    onRequestTopLeftBorderRadius = (newFontSize) => {
        this.setState({ [TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_TOP_LEFT_KEY]: newFontSize }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_TOP_LEFT_KEY, 'Top left border radius for request bubble was saved.');
        });
    }

    onRequestTopRightBorderRadius = (newFontSize) => {
        this.setState({ [TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_TOP_RIGHT_KEY]: newFontSize }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_TOP_RIGHT_KEY, 'Top right border radius for request bubble was saved.');
        });
    }

    onRequestBottomRightBorderRadius = (newFontSize) => {
        this.setState({ [TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_BOTTOM_RIGHT_KEY]: newFontSize }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_BOTTOM_RIGHT_KEY, 'Bottom right border radius for request bubble was saved.');
        });
    }

    onRequestBottomLeftBorderRadius = (newFontSize) => {
        this.setState({ [TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_BOTTOM_LEFT_KEY]: newFontSize }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_BOTTOM_LEFT_KEY, 'Bottom left border radius for request bubble was saved.');
        });
    }

    onTextareaBorderColorClose = () => {
        this.setTextOption(TEXT_CHAT_TEXTAREA_BORDER_COLOR_KEY, 'Border color was saved.');
    }

    onTextareaBorderColorChange = (color) => {
        this.setState({ [TEXT_CHAT_TEXTAREA_BORDER_COLOR_KEY]: color });
    }

    onButtonsBorderColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUTTONS_BORDER_COLOR_KEY, 'Buttons border color was saved.');
    }

    onButtonsHoverBorderColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUTTONS_BORDER_COLOR_HOVER_KEY, 'Buttons border color was saved for hovered state.');
    }

    onButtonsActiveBorderColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUTTONS_BORDER_COLOR_ACTIVE_KEY, 'Buttons border color was saved for clicked state.');
    }

    onRequestBubbleShadowChange = () => {
        this.setTextOption(TEXT_CHAT_BUBBLES_REQUEST_HAS_SHADOW_KEY, 'Request bubble shaodow was saved.');
    }

    onResponseBubbleShadowChange = () => {
        this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_HAS_SHADOW_KEY, 'Response bubble shaodow was saved.');
    }

    onResponseBubbleBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_BACKGROUND_COLOR_KEY, 'Response bubble background color was saved.');
    }
    onRequestBubbleFontColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUBBLES_REQUEST_FONT_COLOR_KEY, 'Request font color was saved.');
    }
    onRequestBubbleFontColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUBBLES_REQUEST_FONT_COLOR_KEY]: color });
    }
    onResponseBubbleFontColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_FONT_COLOR_KEY, 'Response font color was saved.');
    }
    onIconsBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_TEXTAREA_ICONS_DEFAULT_FILL_COLOR_KEY, 'Send and mic. icons background color was saved.');
    }
    onIconsOnHoverBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_TEXTAREA_ICONS_HOVER_FILL_COLOR_KEY, 'Send and mic. icons in hover state background color was saved.');
    }

    onRequestBubbleLabelFontColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUBBLES_REQUEST_LABEL_FONT_COLOR_KEY]: color });
    }
    onRequestBubbleLabelFontColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUBBLES_REQUEST_LABEL_FONT_COLOR_KEY, 'Font color was saved.');
    }

    onResponseBubbleLabelFontColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_LABEL_FONT_COLOR_KEY]: color });
    }
    onResponseBubbleLabelFontColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_LABEL_FONT_COLOR_KEY, 'Font color was saved.');
    }


    onStopResponseIconColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LOADER_ICON_DEFAULT_FILL_COLOR_KEY]: color });
    }
    onStopResponseIconColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LOADER_ICON_DEFAULT_FILL_COLOR_KEY, 'Color was saved.');
    }

    onStopResponseIconHoveredColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LOADER_ICON_HOVER_FILL_COLOR_KEY]: color });
    }
    onStopResponseIconHoveredColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LOADER_ICON_HOVER_FILL_COLOR_KEY, 'Color was saved.');
    }




    onResponseBubbleBottomBtnsColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_BOTTOM_BTNS_COLOR_KEY]: color });
    }
    onResponseBubbleBottomBtnsColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_BOTTOM_BTNS_COLOR_KEY, 'Color was saved.');
    }

    onResponseBubbleBottomBtnsBackgroundHoverColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_BOTTOM_BTNS_BACKGROUND_HOVERED_KEY]: color });
    }
    onResponseBubbleBottomBtnsBackgroundHoverColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_BOTTOM_BTNS_BACKGROUND_HOVERED_KEY, 'Color was saved.');
    }

    onCloseIconSvgChange = (icon) => {
        this.setState({ [TEXT_CHAT_CLOSE_ICON_KEY]: icon }, () => {
            this.setTextOption(TEXT_CHAT_CLOSE_ICON_KEY, 'Close icon was saved.');
        });
    }

    onCloseIconSvgReset = () => {
        this.setState({ [TEXT_CHAT_CLOSE_ICON_KEY]: null }, () => {
            this.setTextOption(TEXT_CHAT_CLOSE_ICON_KEY, 'Close icon was saved.');
        });
    }

    onMinimizeIconSvgChange = (icon) => {
        this.setState({ [TEXT_CHAT_MINIMIZE_ICON_KEY]: icon }, () => {
            this.setTextOption(TEXT_CHAT_MINIMIZE_ICON_KEY, 'Minimize icon was saved.');
        });
    }

    onMinimizeIconSvgReset = () => {
        this.setState({ [TEXT_CHAT_MINIMIZE_ICON_KEY]: null }, () => {
            this.setTextOption(TEXT_CHAT_MINIMIZE_ICON_KEY, 'Minimize icon was saved.');
        });
    }

    onSaveChatStateIconSvgChange = (icon) => {
        this.setState({ [TEXT_CHAT_SAVE_CHAT_STATE_ICON_KEY]: icon }, () => {
            this.setTextOption(TEXT_CHAT_SAVE_CHAT_STATE_ICON_KEY, 'Save chat history icon was saved.');
        });
    }

    onSaveChatStateIconSvgReset = () => {
        this.setState({ [TEXT_CHAT_SAVE_CHAT_STATE_ICON_KEY]: null }, () => {
            this.setTextOption(TEXT_CHAT_SAVE_CHAT_STATE_ICON_KEY, 'Save chat history icon was saved.');
        });
    }

    onHeaderIconSvgChange = (icon) => {
        this.setState({ [TEXT_CHAT_HEADER_LABEL_ICON_KEY]: icon }, () => {
            this.setTextOption(TEXT_CHAT_HEADER_LABEL_ICON_KEY, 'Icon was saved.');
        });
    }

    onHeaderIconSvgReset = () => {
        this.setState({ [TEXT_CHAT_HEADER_LABEL_ICON_KEY]: null }, () => {
            this.setTextOption(TEXT_CHAT_HEADER_LABEL_ICON_KEY, 'Icon was saved.');
        });
    }

    onLoaderIconSvgChange = (icon) => {
        this.setState({ [TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LOADER_ICON_KEY]: icon }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LOADER_ICON_KEY, 'Icon was saved.');
        });
    }

    onLoaderIconSvgReset = () => {
        this.setState({ [TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LOADER_ICON_KEY]: null }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LOADER_ICON_KEY, 'Icon was saved.');
        });
    }

    onResponseLabelIconSvgChange = (icon) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ICON_KEY]: icon }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ICON_KEY, 'Icon was saved.');
        });
    }

    onResponseLabelIconSvgReset = () => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ICON_KEY]: null }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ICON_KEY, 'Icon was saved.');
        });
    }

    onMuteIconSvgChange = (icon) => {
        this.setState({ [TEXT_CHAT_MUTE_ICON_KEY]: icon }, () => {
            this.setTextOption(TEXT_CHAT_MUTE_ICON_KEY, 'Audio output icon was saved.');
        });
    }

    onMuteIconSvgReset = () => {
        this.setState({ [TEXT_CHAT_MUTE_ICON_KEY]: null }, () => {
            this.setTextOption(TEXT_CHAT_MUTE_ICON_KEY, 'Audio output icon was saved.');
        });
    }

    onUnmuteIconSvgChange = (icon) => {
        this.setState({ [TEXT_CHAT_UNMUTE_ICON_KEY]: icon }, () => {
            this.setTextOption(TEXT_CHAT_UNMUTE_ICON_KEY, 'Unmute icon was saved.');
        });
    }

    onUnmuteIconSvgReset = () => {
        this.setState({ [TEXT_CHAT_UNMUTE_ICON_KEY]: null }, () => {
            this.setTextOption(TEXT_CHAT_UNMUTE_ICON_KEY, 'Unmute icon was saved.');
        });
    }

    onSendIconSvgChange = (icon) => {
        this.setState({ [TEXT_CHAT_SEND_ICON_KEY]: icon }, () => {
            this.setTextOption(TEXT_CHAT_SEND_ICON_KEY, 'Send icon was saved.');
        });
    }

    onSendIconSvgReset = () => {
        this.setState({ [TEXT_CHAT_SEND_ICON_KEY]: null }, () => {
            this.setTextOption(TEXT_CHAT_SEND_ICON_KEY, 'Send icon was saved.');
        });
    }

    onMicIconSvgChange = (icon) => {
        this.setState({ [TEXT_CHAT_MIC_ICON_KEY]: icon }, () => {
            this.setTextOption(TEXT_CHAT_MIC_ICON_KEY, 'Microphone icon was saved.');
        });
    }

    onMicIconSvgReset = () => {
        this.setState({ [TEXT_CHAT_MIC_ICON_KEY]: null }, () => {
            this.setTextOption(TEXT_CHAT_MIC_ICON_KEY, 'Microphone icon was saved.');
        });
    }

    onFullScreenModeCollapseIconSvgChange = (icon) => {
        this.setState({ [TEXT_CHAT_POPUP_FULL_SCREEN_MODE_COLLAPSE_ICON_KEY]: icon }, () => {
            this.setTextOption(TEXT_CHAT_POPUP_FULL_SCREEN_MODE_COLLAPSE_ICON_KEY, 'Full screen mode icon was saved.');
        });
    }

    onFullScreenModeCollapseIconSvgReset = () => {
        this.setState({ [TEXT_CHAT_POPUP_FULL_SCREEN_MODE_COLLAPSE_ICON_KEY]: null }, () => {
            this.setTextOption(TEXT_CHAT_POPUP_FULL_SCREEN_MODE_COLLAPSE_ICON_KEY, 'Full screen mode icon was saved.');
        });
    }

    onFullScreenModeExpandIconSvgChange = (icon) => {
        this.setState({ [TEXT_CHAT_POPUP_FULL_SCREEN_MODE_EXPAND_ICON_KEY]: icon }, () => {
            this.setTextOption(TEXT_CHAT_POPUP_FULL_SCREEN_MODE_EXPAND_ICON_KEY, 'Full screen mode icon was saved.');
        });
    }

    onFullScreenModeExpandIconSvgReset = () => {
        this.setState({ [TEXT_CHAT_POPUP_FULL_SCREEN_MODE_EXPAND_ICON_KEY]: null }, () => {
            this.setTextOption(TEXT_CHAT_POPUP_FULL_SCREEN_MODE_EXPAND_ICON_KEY, 'Full screen mode icon was saved.');
        });
    }

    onCloseIconBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_CLOSE_ICON_FILL_COLOR_KEY, 'Close icon background color was saved.');
    }
    onCloseIconBackgroundColorChange = (color) => {
        this.setState({ [TEXT_CHAT_CLOSE_ICON_FILL_COLOR_KEY]: color });
    }
    onCloseIconOnHoverBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_CLOSE_ICON_HOVER_FILL_COLOR_KEY, 'Close icon background color was saved (for active state).');
    }
    onCloseIconOnHoverBackgroundColorChange = (color) => {
        this.setState({ [TEXT_CHAT_CLOSE_ICON_HOVER_FILL_COLOR_KEY]: color });
    }
    onMinimizeIconBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_MINIMIZE_ICON_FILL_COLOR_KEY, 'Minimize icon background color was saved.');
    }
    onMinimizeIconBackgroundColorChange = (color) => {
        this.setState({ [TEXT_CHAT_MINIMIZE_ICON_FILL_COLOR_KEY]: color });
    }
    onMinimizeIconOnHoverBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_MINIMIZE_ICON_HOVER_FILL_COLOR_KEY, 'Minimize icon background color was saved (for active state).');
    }
    onMinimizeIconOnHoverBackgroundColorChange = (color) => {
        this.setState({ [TEXT_CHAT_MINIMIZE_ICON_HOVER_FILL_COLOR_KEY]: color });
    }
    onClearIconBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_CLEAR_ICON_FILL_COLOR_KEY, 'Clear icon background color was saved.');
    }
    onClearIconBackgroundColorChange = (color) => {
        this.setState({ [TEXT_CHAT_CLEAR_ICON_FILL_COLOR_KEY]: color });
    }
    onClearIconOnHoverBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_CLEAR_ICON_HOVER_FILL_COLOR_KEY, 'Clear icon background color was saved (for active state).');
    }

    onClearIconOnHoverBackgroundColorChange = (color) => {
        this.setState({ [TEXT_CHAT_CLEAR_ICON_HOVER_FILL_COLOR_KEY]: color });
    }

    onMuteIconBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_MUTE_ICON_FILL_COLOR_KEY, 'Audio output icon background color was saved.');
    }

    onMuteIconBackgroundColorChange = (color) => {
        this.setState({ [TEXT_CHAT_MUTE_ICON_FILL_COLOR_KEY]: color });
    }

    onMuteIconOnHoverBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_MUTE_ICON_HOVER_FILL_COLOR_KEY, 'Audio output icon background color was saved (for active state).');
    }

    onMuteIconOnHoverBackgroundColorChange = (color) => {
        this.setState({ [TEXT_CHAT_MUTE_ICON_HOVER_FILL_COLOR_KEY]: color });
    }

    onFullScreenIconColorrClose = () => {
        this.setTextOption(TEXT_CHAT_EXPAND_COLLAPSE_ICON_FILL_COLOR_KEY, 'Full screen mode icon color was saved.');
    }

    onFullScreenIconColorChange = (color) => {
        this.setState({ [TEXT_CHAT_EXPAND_COLLAPSE_ICON_FILL_COLOR_KEY]: color });
    }

    onFullScreenOnHoverColorClose = () => {
        this.setTextOption(TEXT_CHAT_EXPAND_COLLAPSE_ICON_HOVER_FILL_COLOR_KEY, 'Full screen mode icon color was saved (for active state).');
    }

    onFullScreenOnHoverColorChange = (color) => {
        this.setState({ [TEXT_CHAT_EXPAND_COLLAPSE_ICON_HOVER_FILL_COLOR_KEY]: color });
    }

    onSaveChatStateIconColorrClose = () => {
        this.setTextOption(TEXT_CHAT_SAVE_TEXT_CHAT_STATE_ICON_FILL_COLOR_KEY, 'Icon color was saved.');
    }

    onSaveChatStateIconColorChange = (color) => {
        this.setState({ [TEXT_CHAT_SAVE_TEXT_CHAT_STATE_ICON_FILL_COLOR_KEY]: color });
    }

    onSaveChatStateOnHoverColorClose = () => {
        this.setTextOption(TEXT_CHAT_SAVE_TEXT_CHAT_STATE_ICON_HOVER_FILL_COLOR_KEY, 'Icon color was saved.');
    }

    onSaveChatStateOnHoverColorChange = (color) => {
        this.setState({ [TEXT_CHAT_SAVE_TEXT_CHAT_STATE_ICON_HOVER_FILL_COLOR_KEY]: color });
    }

    onFontSizeRequestChange = (newFontSize) => {
        this.setState({ [TEXT_CHAT_BUBBLES_REQUEST_BFONT_SIZE_KEY]: newFontSize }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_REQUEST_BFONT_SIZE_KEY, 'Request font size was saved.');
        });
    }

    onFontSizeRequestLabelChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUBBLES_REQUEST_LABEL_FONT_SIZE_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_REQUEST_LABEL_FONT_SIZE_KEY, 'Font size was saved.');
        });
    }

    onFontSizeResponseLabelChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_LABEL_FONT_SIZE_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_LABEL_FONT_SIZE_KEY, 'Font size was saved.');
        });
    }

    onSideBarIconColorChange = () => {
        this.setTextOption(TEXT_CHAT_SIDE_BAR_ICON_FILL_COLOR_KEY, 'Side bar icon color was saved.');
    }
    onSideBarOnHoverColorChange = () => {
        this.setTextOption(TEXT_CHAT_SIDE_BAR_ICON_HOVER_FILL_COLOR_KEY, 'Side bar icon color was saved (for active state).');
    }

    onNotificationColorClose = () => {
        this.setTextOption(TEXT_CHAT_NOTIFICATIONS_BUBBLE_FONT_COLOR_KEY, 'Notifications bubble font color was saved.');
    }
    onNotificationBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_NOTIFICATIONS_BUBBLE_BACKGROUND_COLOR_KEY, 'Notifications bubble background color was saved.');
    }

    onTextareaColorClose = () => {
        this.setTextOption(TEXT_CHAT_TEXTAREA_FONT_COLOR_KEY, 'Font color was saved.');
    }

    onFooterBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_FOOTER_BACKGROUND_COLOR_KEY, 'Background color was saved.');
    }

    onLinkColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_LINK_FONT_COLOR_KEY, 'Link color was saved.');
    }

    onLinkColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_LINK_FONT_COLOR_KEY]: color });
    }

    onLinkHoveredColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_LINK_HOVERED_FONT_COLOR_KEY, 'Link color (hovered) was saved.');
    }

    onLinkHoveredColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_LINK_HOVERED_FONT_COLOR_KEY]: color });
    }

    onButtonsColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUTTONS_FONT_COLOR_KEY, 'Font color was saved.');
    }

    onButtonsHoverColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUTTONS_FONT_COLOR_HOVER_KEY, 'Font color was saved for hovered state.');
    }

    onButtonsActiveColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUTTONS_FONT_COLOR_ACTIVE_KEY, 'Font color was saved for clicked state.');
    }

    onTextareaPlaceholderColorClose = () => {
        this.setTextOption(TEXT_CHAT_TEXTAREA_PLACEHOLDER_FONT_COLOR_KEY, 'Placeholder font color was saved.');
    }

    onTextareaBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_TEXTAREA_BACKGROUND_COLOR_KEY, 'Backround color was saved.');
    }

    onButtonsBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUTTONS_BACKGROUND_COLOR_KEY, 'Buttons color was saved.');
    }

    onButtonsHoverBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUTTONS_BACKGROUND_COLOR_HOVER_KEY, 'Buttons color was saved for hovered state.');
    }

    onAlignOptionsChange = (newAlignment) => {
        this.setState({ [TEXT_CHAT_BUTTONS_ALIGNMENT_DEFAULT_KEY]: newAlignment }, () => {
            this.setTextOption(TEXT_CHAT_BUTTONS_ALIGNMENT_DEFAULT_KEY, 'Buttons alignment was saved.');
        });
    }

    onTextAlignButtonsChange = (newAlignment) => {
        this.setState({ [TEXT_CHAT_BUTTONS_TEXT_ALIGNMENT_DEFAULT_KEY]: newAlignment }, () => {
            this.setTextOption(TEXT_CHAT_BUTTONS_TEXT_ALIGNMENT_DEFAULT_KEY, 'Buttons text alignment was saved.');
        });
    }

    onButtonsActiveBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUTTONS_BACKGROUND_COLOR_ACTIVE_KEY, 'Buttons color was saved for clicked state.');
    }


    onTopLeftBorderRadiusTextChatChanged = (newFontSize) => {
        this.setState({ [TEXT_CHAT_POPUP_BORDER_RADIUS_TOP_LEFT_KEY]: newFontSize }, () => {
            this.setTextOption(TEXT_CHAT_POPUP_BORDER_RADIUS_TOP_LEFT_KEY, 'Top left border radius for text chat was saved.');
        });
    }

    onTopRightBorderRadiusTextChatChanged = (newFontSize) => {
        this.setState({ [TEXT_CHAT_POPUP_BORDER_RADIUS_TOP_RIGHT_KEY]: newFontSize }, () => {
            this.setTextOption(TEXT_CHAT_POPUP_BORDER_RADIUS_TOP_RIGHT_KEY, 'Top right border radius for text chat was saved.');
        });
    }


    onBottomRightBorderRadiusTextChatChanged = (newFontSize) => {
        this.setState({ [TEXT_CHAT_POPUP_BORDER_RADIUS_BOTTOM_RIGHT_KEY]: newFontSize }, () => {
            this.setTextOption(TEXT_CHAT_POPUP_BORDER_RADIUS_BOTTOM_RIGHT_KEY, 'Bottom right border radius for text chat was saved.');
        });
    }

    onBottomLeftBorderRadiusTextChatChanged = (newFontSize) => {
        this.setState({ [TEXT_CHAT_POPUP_BORDER_RADIUS_BOTTOM_LEFT_KEY]: newFontSize }, () => {
            this.setTextOption(TEXT_CHAT_POPUP_BORDER_RADIUS_BOTTOM_LEFT_KEY, 'Bottom left border radius for text chat was saved.');
        });
    }

    onMinHeightChatChange = (minHeightVal) => {
        this.setState({ [TEXT_CHAT_POPUP_MIN_HEIGHT_KEY]: minHeightVal }, () => {
            this.setTextOption(TEXT_CHAT_POPUP_MIN_HEIGHT_KEY, 'Text chat min. height was saved.');
        });
    }

    onMinHeightValidate = (minHeightSize) => {
        if (!(+minHeightSize >= 160 && +minHeightSize <= 1000)) {
            return {
                error: 'Text chat min. height should be in a range from 160px to 1000'
            };
        }

        return {};
    }

    onHeightValidate = (heightSize) => {
        if (!(+heightSize >= 400 && +heightSize <= 1200)) {
            return {
                error: 'Text chat height should be in a range 400px - 1200px'
            };
        }

        return {};
    }

    onHeightChatChange = (heightVal) => {
        this.setState({ [TEXT_CHAT_POPUP_HEIGHT_KEY]: heightVal }, () => {
            this.setTextOption(TEXT_CHAT_POPUP_HEIGHT_KEY, 'Text chat height was saved.');
        });
    }

    onMaxHeightValidate = (maxHeightSize) => {
        if (maxHeightSize && !(+maxHeightSize >= 600 && +maxHeightSize <= 5000)) {
            return {
                error: 'Text chat max. height should be in a range from 600px to 5000, or should be empty'
            };
        }

        return {};
    }


    onMaxHeightChatChange = (maxHeightVal) => {
        this.setState({ [TEXT_CHAT_POPUP_MAX_HEIGHT_KEY]: maxHeightVal }, () => {
            this.setTextOption(TEXT_CHAT_POPUP_MAX_HEIGHT_KEY, 'Text chat max. height was saved.');
        });
    }

    onMinWidthValidate = (val) => {
        if (!(+val >= 250 && +val <= 1000)) {
            return {
                error: 'Text chat min. width should be in a range from 250px to 1000'
            };
        }

        return {};
    }

    onMinWidthChatChange = (val) => {
        this.setState({ [TEXT_CHAT_POPUP_MIN_WIDTH_KEY]: val }, () => {
            this.setTextOption(TEXT_CHAT_POPUP_MIN_WIDTH_KEY, 'Text chat min. width was saved.');
        });
    }


    onWidthValidate = (val) => {
        if (!(+val >= 250 && +val <= 4000)) {
            return {
                error: 'Text chat width should be in a range from 250px to 4000'
            };
        }

        return {};
    }

    onWidthChatChange = (val) => {
        this.setState({ [TEXT_CHAT_POPUP_WIDTH_KEY]: val }, () => {
            this.setTextOption(TEXT_CHAT_POPUP_WIDTH_KEY, 'Text chat width was saved.');
        });
    }


    onMaxWidthValidate = (val) => {
        if (val && !(+val >= 250 && +val <= 4000)) {
            return {
                error: 'Text chat max width should be in a range from 250px to 4000'
            };
        }

        return {};
    }

    onMaxWidthChatChange = (val) => {
        this.setState({ [TEXT_CHAT_POPUP_MAX_WIDTH_KEY]: val }, () => {
            this.setTextOption(TEXT_CHAT_POPUP_MAX_WIDTH_KEY, 'Text chat max. width was saved.');
        });
    }

    onResponseFontSizeChange = (newFontSize) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_FONT_SIZE_KEY]: newFontSize }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_FONT_SIZE_KEY, 'Response font size was saved.');
        });
    }

    onResponseBubbleFontColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_FONT_COLOR_KEY]: color });
    }

    onResponseBubbleBackgroundColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_BACKGROUND_COLOR_KEY]: color });
    }
    onResponseBubbleBorderColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_BORDER_COLOR_KEY]: color });
    }
    onResponseBubbleCodeBackgroundColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_CODE_BACKGROUND_COLOR_KEY]: color });
    }
    onResponseBubbleCodeBorderColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_CODE_BORDER_COLOR_KEY]: color });
    }
    onResponseTopLeftBorderRadius = (newFontSize) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_TOP_LEFT_KEY]: newFontSize }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_TOP_LEFT_KEY, 'Top left border radius for response bubble was saved.');
        });
    }
    onResponseTopRightBorderRadius = (newFontSize) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_TOP_RIGHT_KEY]: newFontSize }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_TOP_RIGHT_KEY, 'Top right border radius for response bubble was saved.');
        });
    }

    onResponseBottomRightBorderRadius = (newFontSize) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_BOTTOM_RIGHT_KEY]: newFontSize }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_BOTTOM_RIGHT_KEY, 'Bottom right border radius for response bubble was saved.');
        });
    }

    onResponseBottomLeftBorderRadius = (newFontSize) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_BOTTOM_LEFT_KEY]: newFontSize }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_BOTTOM_LEFT_KEY, 'Bottom left border radius for response bubble was saved.');
        });
    }

    validatePlaceholder = (val) => {
        if (val.length > 45) {
            return {
                info: `Max placeholder length: 45 characters`
            };
        }
        return {};
    }

    validateWaitingBubbleLabeL = (val) => {
        if (val.length > 45) {
            return {
                info: `Max labeL length: 45 characters`
            };
        }
        return {};
    }


    onTextareaFontSizeChange = (newFontSize) => {
        this.setState({ [TEXT_CHAT_TEXTAREA_FONT_SIZE_KEY]: newFontSize }, () => {
            this.setTextOption(TEXT_CHAT_TEXTAREA_FONT_SIZE_KEY, 'Font size was saved.');
        });
    }

    onTextareaMaxLinesCountChange = (val) => {
        this.setState({ [TEXT_CHAT_TEXTAREA_MAX_LINES_COUNT_KEY]: val }, () => {
            this.setTextOption(TEXT_CHAT_TEXTAREA_MAX_LINES_COUNT_KEY, 'Max lines count was saved.');
        });
    }

    onFooterBackgroundColorChange = (color) => {
        this.setState({ [TEXT_CHAT_FOOTER_BACKGROUND_COLOR_KEY]: color });
    }

    onTextareaColorChange = (color) => {
        this.setState({ [TEXT_CHAT_TEXTAREA_FONT_COLOR_KEY]: color });
    }

    onTextareaPlaceholderColorChange = (color) => {
        this.setState({ [TEXT_CHAT_TEXTAREA_PLACEHOLDER_FONT_COLOR_KEY]: color });
    }

    onTextareaBackgroundColorChange = (color) => {
        this.setState({ [TEXT_CHAT_TEXTAREA_BACKGROUND_COLOR_KEY]: color });
    }

    onIconsBackgroundColorChange = (color) => {
        this.setState({ [TEXT_CHAT_TEXTAREA_ICONS_DEFAULT_FILL_COLOR_KEY]: color });
    }
    onIconsOnHoverBackgroundColorChange = (color) => {
        this.setState({ [TEXT_CHAT_TEXTAREA_ICONS_HOVER_FILL_COLOR_KEY]: color });
    }
    onTextareaTopLeftBorderRadiusChange = (newFontSize) => {
        this.setState({ [TEXT_CHAT_TEXTAREA_BORDER_RADIUS_TOP_LEFT_KEY]: newFontSize }, () => {
            this.setTextOption(TEXT_CHAT_TEXTAREA_BORDER_RADIUS_TOP_LEFT_KEY, 'Top left border radius for textarea was saved.');
        });
    }

    onTextareaTopRightBorderRadiusChange = (newFontSize) => {
        this.setState({ [TEXT_CHAT_TEXTAREA_BORDER_RADIUS_TOP_RIGHT_KEY]: newFontSize }, () => {
            this.setTextOption(TEXT_CHAT_TEXTAREA_BORDER_RADIUS_TOP_RIGHT_KEY, 'Top right border radius for textarea was saved.');
        });
    }

    onTextareaBottomRightBorderRadiusChange = (newFontSize) => {
        this.setState({ [TEXT_CHAT_TEXTAREA_BORDER_RADIUS_BOTTOM_RIGHT_KEY]: newFontSize }, () => {
            this.setTextOption(TEXT_CHAT_TEXTAREA_BORDER_RADIUS_BOTTOM_RIGHT_KEY, 'Bottom right border radius for textarea was saved.');
        });
    }

    onTextareaBottomLeftBorderRadiusChange = (newFontSize) => {
        this.setState({ [TEXT_CHAT_TEXTAREA_BORDER_RADIUS_BOTTOM_LEFT_KEY]: newFontSize }, () => {
            this.setTextOption(TEXT_CHAT_TEXTAREA_BORDER_RADIUS_BOTTOM_LEFT_KEY, 'Bottom left border radius for textarea was saved.');
        });
    }

    onButtonsFontSizeChange = (newFontSize) => {
        this.setState({ [TEXT_CHAT_BUTTONS_FONT_SIZE_KEY]: newFontSize }, () => {
            this.setTextOption(TEXT_CHAT_BUTTONS_FONT_SIZE_KEY, 'Font size was saved.');
        });
    }

    onBtnsTopLeftBorderRadiusChange = (newFontSize) => {
        this.setState({ [TEXT_CHAT_BUTTONS_BORDER_RADIUS_TOP_LEFT_KEY]: newFontSize }, () => {
            this.setTextOption(TEXT_CHAT_BUTTONS_BORDER_RADIUS_TOP_LEFT_KEY, 'Top left border radius for buttons in text chat was saved.');
        });
    }

    onBtnsTopRightBorderRadiusChange = (newFontSize) => {
        this.setState({ [TEXT_CHAT_BUTTONS_BORDER_RADIUS_TOP_RIGHT_KEY]: newFontSize }, () => {
            this.setTextOption(TEXT_CHAT_BUTTONS_BORDER_RADIUS_TOP_RIGHT_KEY, 'Top right border radius for buttons in text chat was saved.');
        });
    }

    onBtnsBottomRightBorderRadiusChange = (newFontSize) => {
        this.setState({ [TEXT_CHAT_BUTTONS_BORDER_RADIUS_BOTTOM_RIGHT_KEY]: newFontSize }, () => {
            this.setTextOption(TEXT_CHAT_BUTTONS_BORDER_RADIUS_BOTTOM_RIGHT_KEY, 'Bottom right border radius for buttons in text chat was saved.');
        });
    }
    onBtnsBottomLeftBorderRadiusChange = (newFontSize) => {
        this.setState({ [TEXT_CHAT_BUTTONS_BORDER_RADIUS_BOTTOM_LEFT_KEY]: newFontSize }, () => {
            this.setTextOption(TEXT_CHAT_BUTTONS_BORDER_RADIUS_BOTTOM_LEFT_KEY, 'Bottom left border radius for buttons in text chat was saved.');
        });
    }
    onBtnsGapChange = (val) => {
        this.setState({ [TEXT_CHAT_BUTTONS_GAP_KEY]: val }, () => {
            this.setTextOption(TEXT_CHAT_BUTTONS_GAP_KEY, 'Gap for buttons in text chat was saved.');
        });
    }

    onLoaderLabelIconGapChange = (val) => {
        this.setState({ [TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LABEL_ICON_GAP_KEY]: val }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LABEL_ICON_GAP_KEY, 'Gap was saved.');
        });
    }

    onHeaderIconGapChange = (val) => {
        this.setState({ [TEXT_CHAT_HEADER_LABEL_ICON_GAP_KEY]: val }, () => {
            this.setTextOption(TEXT_CHAT_HEADER_LABEL_ICON_GAP_KEY, 'Gap for icon in header was saved.');
        });
    }

    onResponseLabelIconGapChange = (val) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ICON_GAP_KEY]: val }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ICON_GAP_KEY, 'Gap for icon was saved.');
        });
    }

    onLearnMoreLinkBorderColorChange = (color) => {
        this.setState({ [TEXT_CHAT_LEAR_MORE_LINKS_DEFAULT_BORDER_COLOR_KEY]: color });
    }

    onLearnMoreLinkHoverBorderColorChange = (color) => {
        this.setState({ [TEXT_CHAT_LEAR_MORE_LINKS_HOVER_BORDER_COLOR_KEY]: color });
    }

    onLearnMoreLinkActiveBorderColorChange = (color) => {
        this.setState({ [TEXT_CHAT_LEAR_MORE_LINKS_ACTIVE_BORDER_COLOR_KEY]: color });
    }

    onLearnMoreLinkBorderColorClose = () => {
        this.setTextOption(TEXT_CHAT_LEAR_MORE_LINKS_DEFAULT_BORDER_COLOR_KEY, 'Border color was saved.');
    }

    onLearnMoreLinkHoverBorderColorClose = () => {
        this.setTextOption(TEXT_CHAT_LEAR_MORE_LINKS_HOVER_BORDER_COLOR_KEY, 'Border color was saved for hovered state.');
    }

    onLearnMoreLinkActiveBorderColorClose = () => {
        this.setTextOption(TEXT_CHAT_LEAR_MORE_LINKS_ACTIVE_BORDER_COLOR_KEY, 'Border color was saved for clicked state.');
    }

    onTableBorderColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_TABLE_BORDER_COLOR_KEY]: color });
    }

    onTableBorderColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_TABLE_BORDER_COLOR_KEY, 'Border color was saved.');
    }

    onNewDialogSeparatorColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUBBLES_NEW_DIALOG_SEPARATOR_COLOR_KEY]: color });
    }

    onNewDialogSeparatorColorClose = () => {
        this.setTextOption(TEXT_CHAT_BUBBLES_NEW_DIALOG_SEPARATOR_COLOR_KEY, 'Color was saved.');
    }

    onLearnMoreLinkLinkNumberBackgroundColorChange = (color) => {
        this.setState({ [TEXT_CHAT_LEAR_MORE_LINKS_LINK_NUMBER_DEFAULT_BACKGROUND_COLOR_KEY]: color });
    }

    onLearnMoreLinkHoverLinkNumberBackgroundColorChange = (color) => {
        this.setState({ [TEXT_CHAT_LEAR_MORE_LINKS_LINK_NUMBER_HOVER_BACKGROUND_COLOR_KEY]: color });
    }

    onLearnMoreLinkActiveLinkNumberBackgroundColorChange = (color) => {
        this.setState({ [TEXT_CHAT_LEAR_MORE_LINKS_LINK_NUMBER_ACTIVE_BACKGROUND_COLOR_KEY]: color });
    }


    onLearnMoreLinkLinkNumberBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_LEAR_MORE_LINKS_LINK_NUMBER_DEFAULT_BACKGROUND_COLOR_KEY, 'Background color was saved.');
    }

    onLearnMoreLinkHoverLinkNumberBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_LEAR_MORE_LINKS_LINK_NUMBER_HOVER_BACKGROUND_COLOR_KEY, 'Background color was saved for hovered state.');
    }

    onLearnMoreLinkActiveLinkNumberBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_LEAR_MORE_LINKS_LINK_NUMBER_ACTIVE_BACKGROUND_COLOR_KEY, 'Background color was saved for clicked state.');
    }


    onLearnMoreLinkBackgroundColorChange = (color) => {
        this.setState({ [TEXT_CHAT_LEAR_MORE_LINKS_LINK_DEFAULT_BACKGROUND_COLOR_KEY]: color });
    }

    onLearnMoreLinkHoverBackgroundColorChange = (color) => {
        this.setState({ [TEXT_CHAT_LEAR_MORE_LINKS_LINK_HOVER_BACKGROUND_COLOR_KEY]: color });
    }

    onLearnMoreLinkActiveBackgroundColorChange = (color) => {
        this.setState({ [TEXT_CHAT_LEAR_MORE_LINKS_LINK_ACTIVE_BACKGROUND_COLOR_KEY]: color });
    }


    onLearnMoreLinkBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_LEAR_MORE_LINKS_LINK_DEFAULT_BACKGROUND_COLOR_KEY, 'Background color was saved.');
    }

    onLearnMoreLinkHoverBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_LEAR_MORE_LINKS_LINK_HOVER_BACKGROUND_COLOR_KEY, 'Background color was saved for hovered state.');
    }

    onLearnMoreLinkActiveBackgroundColorClose = () => {
        this.setTextOption(TEXT_CHAT_LEAR_MORE_LINKS_LINK_ACTIVE_BACKGROUND_COLOR_KEY, 'Background color was saved for clicked state.');
    }

    onButtonsColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUTTONS_FONT_COLOR_KEY]: color });
    }

    onButtonsHoverColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUTTONS_FONT_COLOR_HOVER_KEY]: color });
    }

    onButtonsActiveColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUTTONS_FONT_COLOR_ACTIVE_KEY]: color });
    }

    onButtonsBackgroundColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUTTONS_BACKGROUND_COLOR_KEY]: color });
    }
    onButtonsHoverBackgroundColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUTTONS_BACKGROUND_COLOR_HOVER_KEY]: color });
    }

    onButtonsActiveBackgroundColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUTTONS_BACKGROUND_COLOR_ACTIVE_KEY]: color });
    }

    onButtonsBorderColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUTTONS_BORDER_COLOR_KEY]: color });
    }

    onButtonsHoverBorderColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUTTONS_BORDER_COLOR_HOVER_KEY]: color });
    }

    onButtonsActiveBorderColorChange = (color) => {
        this.setState({ [TEXT_CHAT_BUTTONS_BORDER_COLOR_ACTIVE_KEY]: color });
    }

    onBtnHasShadowActiveChange = () => {
        this.toggleBoolOption(TEXT_CHAT_BUTTONS_HAS_SHADOW_ACTIVE_KEY);
    }

    onQueryProgressEnabledChange = () => {
        this.toggleBoolOption(TEXT_CHAT_BUBBLES_WAITING_RESPONSE_QUERY_PROGRESS_ENABLED_KEY);
    }

    onNotificationColorChange = (color) => {
        this.setState({ [TEXT_CHAT_NOTIFICATIONS_BUBBLE_FONT_COLOR_KEY]: color });
    }
    onNotificationBackgroundColorChange = (color) => {
        this.setState({ [TEXT_CHAT_NOTIFICATIONS_BUBBLE_BACKGROUND_COLOR_KEY]: color });
    }

    onBtnsAlignmentDefaultChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUTTONS_ALIGNMENT_DEFAULT_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUTTONS_ALIGNMENT_DEFAULT_KEY, 'Alignment for buttons was changed.');
        });
    }

    onGradientTypeChange = (newVal) => {
        this.setState({ [TEXT_CHAT_POPUP_BACKGROUND_GRADIENT_TYPE_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_POPUP_BACKGROUND_GRADIENT_TYPE_KEY, 'Gradient type was changed.');
        });
    }

    onHeaderLogoLabelAlignmentChange = (newVal) => {
        this.setState({ [TEXT_CHAT_HEADER_LABEL_ALIGNMENT_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_HEADER_LABEL_ALIGNMENT_KEY, 'Alignment was changed.');
        });
    }

    onWaitingResponseBubbleAlignmentChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUBBLES_WAITING_RESPONSE_ALIGNMENT_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_WAITING_RESPONSE_ALIGNMENT_KEY, 'Alignment was changed.');
        });
    }

    onResponseBubbleLogoLabelAlignmentChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ALIGNMENT_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ALIGNMENT_KEY, 'Alignment was changed.');
        });
    }

    onResponseBubbleCodeThemeChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_CODE_THEME_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_CODE_THEME_KEY, 'Code theme was changed.');
        });
    }

    onHeaderLayoutNameChange = (newVal) => {
        this.setState({ [TEXT_CHAT_HEADER_LAYOUT_NAME_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_HEADER_LAYOUT_NAME_KEY, `Header's layout was changed.`);
        });
    }

    onFooterLayoutNameChange = (newVal) => {
        this.setState({ [TEXT_CHAT_FOOTER_LAYOUT_NAME_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_FOOTER_LAYOUT_NAME_KEY, `Footer's layout was changed.`);
        });
    }

    onWaitingBubbleLayoutNameChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LAYOUT_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LAYOUT_KEY, `Waiting response bubble's layout was changed.`);
        });
    }

    onTextInputTypeChange = (newVal) => {
        this.setState({ [TEXT_CHAT_TEXTAREA_FIELD_TYPE_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_TEXTAREA_FIELD_TYPE_KEY, `Input type was changed was changed.`);
        });
    }

    onBtnsAlignmentFullScreenChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUTTONS_ALIGNMENT_FULL_SCREEN_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUTTONS_ALIGNMENT_FULL_SCREEN_KEY, 'Alignment for buttons in full screen mode was changed');
        });
    }

    onFontSelect = (fontItem) => {
        if (fontItem.key === this.state[TEXT_CHAT_POPUP_FONT_FAMILY_KEY]) {
            this.setState({ fontFamilyUpdateTs: Date.now() });
        } else {
            this.onSaveFontFamily(fontItem.key);
        }
    }

    onChatNameValidate = (val) => {
        if (val.length > 50) {
            return {
                info: `Max chat name length: 50 characters`
            };
        }
        return {};
    }

    onCustomBgValidate = (val) => {
        if (val.length <= 0) {
            return {
                info: `Custom background cannot be empty`
            };
        }
        return {};
    }


    onBubbleLabelValidate = (val) => {
        if (val.length > 100) {
            return {
                info: `Max chat name length: 100 characters`
            };
        }
        return {};
    }

    onFontSizeHeaderChange = (newFontSize) => {
        this.setState({ [TEXT_CHAT_HEADER_FONT_SIZE_KEY]: newFontSize }, () => {
            this.setTextOption(TEXT_CHAT_HEADER_FONT_SIZE_KEY, 'Header font size was saved.');
        });
    }

    validateFontSizeValue = (fontSize) => {
        if (!(+fontSize >= 10 && +fontSize <= 22)) {
            return {
                error: 'Font size should be in a range from 10 to 22'
            };
        }

        return {};
    }

    validateMaxLinesCountForTextarea = (val) => {
        if (!(+val >= 2 && +val <= 12)) {
            return {
                error: 'Max lines count should be in a range from 2 to 12'
            };
        }

        return {};
    }

    onHeaderHeightChange = (newHeight) => {
        this.setState({ [TEXT_CHAT_HEADER_HEIGHT_KEY]: newHeight }, () => {
            this.setTextOption(TEXT_CHAT_HEADER_HEIGHT_KEY, 'Header height was saved.');
        });
    }


    validateHeaderHeightValue = (height) => {
        if (!(+height >= 30 && +height <= 80)) {
            return {
                error: 'Height should be in a range from 30 to 80'
            };
        }

        return {};
    }

    onFooterHeightChange = (newHeight) => {
        this.setState({ [TEXT_CHAT_FOOTER_HEIGHT_KEY]: newHeight }, () => {
            this.setTextOption(TEXT_CHAT_FOOTER_HEIGHT_KEY, 'Footer height was saved.');
        });
    }

    validateTextareaPaddingValue = (val) => {
        if (!(+val >= 0 && +val <= 40)) {
            return {
                error: 'Padding should be in a range from 0 to 40'
            };
        }

        return {};
    }

    onTextareaPaddingTopHeightChange = (newVal) => {
        this.setState({ [TEXT_CHAT_TEXTAREA_PADDING_TOP_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_TEXTAREA_PADDING_TOP_KEY, 'Padding was saved.');
        });
    }

    onTextareaPaddingRightHeightChange = (newVal) => {
        this.setState({ [TEXT_CHAT_TEXTAREA_PADDING_RIGHT_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_TEXTAREA_PADDING_RIGHT_KEY, 'Padding was saved.');
        });
    }

    onTextareaPaddingBottomHeightChange = (newVal) => {
        this.setState({ [TEXT_CHAT_TEXTAREA_PADDING_BOTTOM_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_TEXTAREA_PADDING_BOTTOM_KEY, 'Padding was saved.');
        });
    }

    onTextareaPaddingLeftHeightChange = (newVal) => {
        this.setState({ [TEXT_CHAT_TEXTAREA_PADDING_LEFT_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_TEXTAREA_PADDING_LEFT_KEY, 'Padding was saved.');
        });
    }


    validateFooterPaddingValue = (height) => {
        if (!(+height >= 0 && +height <= 40)) {
            return {
                error: 'Padding should be in a range from 0 to 40'
            };
        }

        return {};
    }

    onFooterPaddingTopHeightChange = (newVal) => {
        this.setState({ [TEXT_CHAT_FOOTER_PADDING_TOP_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_FOOTER_PADDING_TOP_KEY, 'Padding was saved.');
        });
    }

    onFooterPaddingRightHeightChange = (newVal) => {
        this.setState({ [TEXT_CHAT_FOOTER_PADDING_RIGHT_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_FOOTER_PADDING_RIGHT_KEY, 'Padding was saved.');
        });
    }

    onFooterPaddingBottomHeightChange = (newVal) => {
        this.setState({ [TEXT_CHAT_FOOTER_PADDING_BOTTOM_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_FOOTER_PADDING_BOTTOM_KEY, 'Padding was saved.');
        });
    }

    onFooterPaddingLeftHeightChange = (newVal) => {
        this.setState({ [TEXT_CHAT_FOOTER_PADDING_LEFT_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_FOOTER_PADDING_LEFT_KEY, 'Padding was saved.');
        });
    }

    validateHeaderPaddingValue = (height) => {
        if (!(+height >= 0 && +height <= 40)) {
            return {
                error: 'Padding should be in a range from 0 to 40'
            };
        }

        return {};
    }

    validatePopupPaddingValue = (val) => {
        if (!(+val >= 0 && +val <= 40)) {
            return {
                error: 'Padding should be in a range from 0 to 40'
            };
        }

        return {};
    }

    onPopupPaddingTopHeightChange = (newVal) => {
        this.setState({ [TEXT_CHAT_POPUP_PADDING_TOP_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_POPUP_PADDING_TOP_KEY, 'Padding was saved.');
        });
    }

    onPopupPaddingRightHeightChange = (newVal) => {
        this.setState({ [TEXT_CHAT_POPUP_PADDING_RIGHT_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_POPUP_PADDING_RIGHT_KEY, 'Padding was saved.');
        });
    }

    onPopupPaddingBottomHeightChange = (newVal) => {
        this.setState({ [TEXT_CHAT_POPUP_PADDING_BOTTOM_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_POPUP_PADDING_BOTTOM_KEY, 'Padding was saved.');
        });
    }

    onPopupPaddingLeftHeightChange = (newVal) => {
        this.setState({ [TEXT_CHAT_POPUP_PADDING_LEFT_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_POPUP_PADDING_LEFT_KEY, 'Padding was saved.');
        });
    }

    onHeaderPaddingTopHeightChange = (newVal) => {
        this.setState({ [TEXT_CHAT_HEADER_PADDING_TOP_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_HEADER_PADDING_TOP_KEY, 'Padding was saved.');
        });
    }

    onHeaderPaddingRightHeightChange = (newVal) => {
        this.setState({ [TEXT_CHAT_HEADER_PADDING_RIGHT_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_HEADER_PADDING_RIGHT_KEY, 'Padding was saved.');
        });
    }

    onHeaderPaddingBottomHeightChange = (newVal) => {
        this.setState({ [TEXT_CHAT_HEADER_PADDING_BOTTOM_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_HEADER_PADDING_BOTTOM_KEY, 'Padding was saved.');
        });
    }

    onHeaderPaddingLeftHeightChange = (newVal) => {
        this.setState({ [TEXT_CHAT_HEADER_PADDING_LEFT_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_HEADER_PADDING_LEFT_KEY, 'Padding was saved.');
        });
    }

    validateButtonsPaddingValue = (height) => {
        if (!(+height >= 0 && +height <= 40)) {
            return {
                error: 'Padding should be in a range from 0 to 40'
            };
        }

        return {};
    }

    onButtonsPaddingTopHeightChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUTTONS_PADDING_TOP_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUTTONS_PADDING_TOP_KEY, 'Padding was saved.');
        });
    }

    onButtonsPaddingRightHeightChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUTTONS_PADDING_RIGHT_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUTTONS_PADDING_RIGHT_KEY, 'Padding was saved.');
        });
    }

    onButtonsPaddingBottomHeightChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUTTONS_PADDING_BOTTOM_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUTTONS_PADDING_BOTTOM_KEY, 'Padding was saved.');
        });
    }

    onButtonsPaddingLeftHeightChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUTTONS_PADDING_LEFT_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUTTONS_PADDING_LEFT_KEY, 'Padding was saved.');
        });
    }

    validateFooterHeightValue = (height) => {
        if (!(+height >= 60 && +height <= 100)) {
            return {
                error: 'Height should be in a range from 60 to 100'
            };
        }

        return {};
    }

    validateBubblesLabelPaddingValue = (val) => {
        if (!(+val >= 0 && +val <= 40)) {
            return {
                error: 'Padding should be in a range from 0 to 40'
            };
        }

        return {};
    }

    onRequestBubbleLabelPaddingTopChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_TOP_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_TOP_KEY, 'Padding was saved.');
        });
    }

    onRequestBubbleLabelPaddingRightChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_RIGHT_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_RIGHT_KEY, 'Padding was saved.');
        });
    }

    onRequestBubbleLabelPaddingBottomChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_BOTTOM_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_BOTTOM_KEY, 'Padding was saved.');
        });
    }

    onRequestBubbleLabelPaddingLeftChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_LEFT_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_LEFT_KEY, 'Padding was saved.');
        });
    }

    onResponseBubbleLabelPaddingTopChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_TOP_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_TOP_KEY, 'Padding was saved.');
        });
    }

    onResponseBubbleLabelPaddingRightChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_RIGHT_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_RIGHT_KEY, 'Padding was saved.');
        });
    }

    onResponseBubbleLabelPaddingBottomChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_BOTTOM_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_BOTTOM_KEY, 'Padding was saved.');
        });
    }

    onResponseBubbleLabelPaddingLeftChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_LEFT_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_LEFT_KEY, 'Padding was saved.');
        });
    }

    validateBubblesPaddingValue = (val) => {
        if (!(+val >= 0 && +val <= 40)) {
            return {
                error: 'Padding should be in a range from 0 to 40'
            };
        }

        return {};
    }

    onRequestBubblePaddingTopChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUBBLES_REQUEST_PADDING_TOP_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_REQUEST_PADDING_TOP_KEY, 'Padding was saved.');
        });
    }

    onRequestBubblePaddingRightChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUBBLES_REQUEST_PADDING_RIGHT_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_REQUEST_PADDING_RIGHT_KEY, 'Padding was saved.');
        });
    }

    onRequestBubblePaddingBottomChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUBBLES_REQUEST_PADDING_BOTTOM_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_REQUEST_PADDING_BOTTOM_KEY, 'Padding was saved.');
        });
    }

    onRequestBubblePaddingLeftChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUBBLES_REQUEST_PADDING_LEFT_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_REQUEST_PADDING_LEFT_KEY, 'Padding was saved.');
        });
    }

    onResponseBubblePaddingTopChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_PADDING_TOP_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_PADDING_TOP_KEY, 'Padding was saved.');
        });
    }

    onResponseBubblePaddingRightChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_PADDING_RIGHT_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_PADDING_RIGHT_KEY, 'Padding was saved.');
        });
    }

    onResponseBubblePaddingBottomChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_PADDING_BOTTOM_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_PADDING_BOTTOM_KEY, 'Padding was saved.');
        });
    }

    onResponseBubblePaddingLeftChange = (newVal) => {
        this.setState({ [TEXT_CHAT_BUBBLES_RESPONSE_PADDING_LEFT_KEY]: newVal }, () => {
            this.setTextOption(TEXT_CHAT_BUBBLES_RESPONSE_PADDING_LEFT_KEY, 'Padding was saved.');
        });
    }

    onTopLeftBorderRadiusLearnMoreLinkChanged = (val) => {
        this.setState({ [TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_TOP_LEFT_KEY]: val }, () => {
            this.setTextOption(TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_TOP_LEFT_KEY, 'Top left border radius for link block was saved.');
        });
    }

    onTopRightBorderRadiusLearnMoreLinkChanged = (val) => {
        this.setState({ [TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_TOP_RIGHT_KEY]: val }, () => {
            this.setTextOption(TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_TOP_RIGHT_KEY, 'Top right border radius for link block was saved.');
        });
    }


    onBottomRightBorderRadiusLearnMoreLinkChanged = (val) => {
        this.setState({ [TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_BOTTOM_RIGHT_KEY]: val }, () => {
            this.setTextOption(TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_BOTTOM_RIGHT_KEY, 'Bottom right border radius for link block was saved.');
        });
    }

    onBottomLeftBorderRadiusLearnMoreLinkChanged = (val) => {
        this.setState({ [TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_BOTTOM_LEFT_KEY]: val }, () => {
            this.setTextOption(TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_BOTTOM_LEFT_KEY, 'Bottom left border radius for link block was saved.');
        });
    }

    validateLearnMoreBorderRadiusSizeValue = (val) => {
        if (!(+val >= 0 && +val <= 20)) {
            return {
                error: 'Border radius should be in a range from 0 to 30'
            };
        }

        return {};
    }

    validateBorderRadiusSizeValue = (fontSize) => {
        if (!(+fontSize >= 0 && +fontSize <= 30)) {
            return {
                error: 'Border radius should be in a range from 0 to 30'
            };
        }

        return {};
    }

    validateResponseLabelIconGapValue = (val) => {
        if (!(+val >= 0 && +val <= 40)) {
            return {
                error: 'Gap should be in a range from 0 to 40'
            };
        }

        return {};
    }

    validateHeaderIconGapValue = (val) => {
        if (!(+val >= 0 && +val <= 40)) {
            return {
                error: 'Gap should be in a range from 0 to 40'
            };
        }

        return {};
    }

    validateBtnsGapValue = (val) => {
        if (!(+val >= 0 && +val <= 40)) {
            return {
                error: 'Gap should be in a range from 0 to 40'
            };
        }

        return {};
    }

    validateLoaderIconGapValue = (val) => {
        if (!(+val >= 0 && +val <= 40)) {
            return {
                error: 'Gap should be in a range from 0 to 40'
            };
        }

        return {};
    }

    validateNumberInput = (fontSize) => {
        const re = /^[0-9\.\b]+$/;
        if (fontSize === '' || re.test(fontSize)) {
            return true;
        }
        return false;
    }

    searchByFonts = ({ query }) => {
        return fetch(`/web/fonts.json?=${Date.now()}`).then(response => response.json()).then((fonts) => {
            const filteredFonts = fonts.filter(font => {
                return font.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
            }).slice(0, 40);

            return filteredFonts;
        }).catch(() => {
            ToasterService.showError({ title: 'Failed to fetch fonts. Refresh the page and try again' });
        });
    }

    restoreScrollPosition = () => {
        if (isLocalStorageAvailable() && this.optionsContainerRef?.current) {
            this.optionsContainerRef.current.scrollTop = +localStorage.getItem(`alan-chat-options-scroll-top-pos`);
        }
    }

    saveScrollPosition = (y) => {
        if (isLocalStorageAvailable()) {
            localStorage.setItem(`alan-chat-options-scroll-top-pos`, y);
        }
    }

    rememberScroll = _.debounce(this.saveScrollPosition, 300)

    onScroll = (e) => {
        this.rememberScroll(e.target.scrollTop);
    }

    render() {
        const {
            project,
            platform,
            environment,
            cohorts,
            selectedCohortId,
        } = this.props;

        const btnOptions = getProjectOptionsByEnvironment(project, platform, environment, cohorts, selectedCohortId)[platform];

        const textChatEnabled = this.state[TEXT_CHAT_ENABLED_KEY];
        const fullScreenModeEnabled = this.state[TEXT_CHAT_POPUP_FULL_SCREEN_MODE_ENABLED_KEY];
        const saveChatStateEnabled = this.state[TEXT_CHAT_POPUP_SAVE_CHAT_STATE_ENABLED_KEY];
        const fontFamily = this.state[TEXT_CHAT_POPUP_FONT_FAMILY_KEY];

        const isRadialGradient = this.state[TEXT_CHAT_POPUP_BACKGROUND_GRADIENT_TYPE_KEY] === 'radial';
        const bg1InfoLabel = isRadialGradient ? 'center' : 'top';
        const bg2InfoLabel = isRadialGradient ? 'sides' : 'bottom';

        const isAudioOutputIconVisible = this.state[TEXT_CHAT_AUDIO_VISIBLE_KEY];
        const isClearIconVisible = this.state[TEXT_CHAT_CLEAR_ICON_VISIBLE_KEY];
        const waitingResponseBubbleLayout = this.state[TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LAYOUT_KEY];

        const isCopyBtnActive = this.state[TEXT_CHAT_BUBBLES_RESPONSE_COPY_BTN_KEY];
        const isFeedbackBtnsActive = this.state[TEXT_CHAT_BUBBLES_RESPONSE_LIKE_BTN_KEY];

        const {
            previewMode,
            fontFamilyUpdateTs
        } = this.state;

        return <div className="text-chat-options">
            <div className="alan-button-options_table no-bottom-margin">
                <div className="alan-button-options_table_column"
                    ref={this.optionsContainerRef}
                    onScroll={this.onScroll}
                >
                    <div className={`text-chat-options_group-name`}>General</div>

                    <SwitcherOption
                        label="Enable text chat"
                        value={textChatEnabled}
                        onClick={this.setEnabledSettings}
                        tooltip="Displays a text chat for the voice assistant button"
                        tooltipId="enableTextChatSettings"
                    />

                    <div className={!textChatEnabled ? 'disabled' : ''}>
                        {platform === 'web' &&
                            <SwitcherOption
                                label="Open text chat by default"
                                value={this.state[TEXT_CHAT_POPUP_OPEN_BY_DEFAULT_KEY]}
                                onClick={this.setOpenByDefaultSettings}
                                tooltip="Opens a text chat when the voice assistant button is displayed"
                                tooltipId="textChatOpenByDefaultSettings"

                            />
                        }

                        <SwitcherOption
                            label="Enable voice input in text chat"
                            value={this.state[TEXT_CHAT_VOICE_ENABLED_KEY]}
                            onClick={this.setVoiceEnabledSettings}
                            tooltip="Enables voice input in the text chat"
                            tooltipId="voiceEnabletSettings"

                        />

                        <SwitcherOption
                            label="Show audio output mode icon"
                            value={isAudioOutputIconVisible}
                            onClick={this.setAudioVisibilitySettings}
                            tooltip="Enables switching audio output mode"
                            tooltipId="audioOutputEnabledSettings"
                        />

                        <SwitcherOption
                            className={isAudioOutputIconVisible === false ? 'disabled' : ''}
                            label="Enable audio output"
                            value={this.state[TEXT_CHAT_AUDIO_ENABLED_KEY]}
                            onClick={this.setAudioEnabledSettings}
                            tooltip="Enables audio output"
                            tooltipId="audioOutputEnabledSettings"
                        />


                        {platform === 'web' &&
                            <SwitcherOption
                                label="Enable full screen mode"
                                value={this.state[TEXT_CHAT_POPUP_FULL_SCREEN_MODE_ENABLED_KEY]}
                                onClick={this.setFullScreenModeSettings}
                                tooltip="Enable opening the text chat in full screen mode"
                                tooltipId="textChatOpenByDefaultSettings"

                            />}

                        {platform === 'web' &&
                            <SwitcherOption
                                label="Enable exporting the chat history"
                                value={this.state[TEXT_CHAT_POPUP_SAVE_CHAT_STATE_ENABLED_KEY]}
                                onClick={this.setSaveTextChatHistorySettings}
                                tooltip="Enables users to download a transcript of the chat conversation"
                                tooltipId="textChatSaveHistorySettings"

                            />}

                        {platform === 'web' &&
                            <SwitcherOption
                                label="Clear chat on close"
                                value={this.state[TEXT_CHAT_POPUP_CLEAR_CHAT_ON_CLOSE_KEY]}
                                onClick={this.setClearChatOnCloseSettings}
                                tooltip="Automatically clear the chat history when the chat window is closed using the close icon."
                                tooltipId="clearChatOnCloseSettings"

                            />}

                        <ComboBoxOption
                            tooltipId="gradientSettings"
                            tooltip="Set gradient type for chat's background"
                            label="Gradient type"
                            values={gradientTypes}
                            value={this.state[TEXT_CHAT_POPUP_BACKGROUND_GRADIENT_TYPE_KEY]}
                            onChange={this.onGradientTypeChange}
                        />

                        {this.state[TEXT_CHAT_POPUP_BACKGROUND_GRADIENT_TYPE_KEY] === 'custom' &&
                            <InputOption
                                tooltipId="customGradientSettings"
                                tooltip="Sets the custom background for the text chat"
                                label="Custom"
                                value={this.state[TEXT_CHAT_POPUP_BACKGROUND_CUSTOM_KEY]}
                                onValidate={this.onCustomBgValidate}
                                onConfirm={this.onCustomBgChanged}
                            />}


                        <ColorPickerOption
                            tooltipId="headerFontColorSettings"
                            tooltip="Sets the top color for the text chat background gradient"
                            label={`Background gradient color (${bg1InfoLabel})`}
                            disableAlpha={true}
                            color={this.state[TEXT_CHAT_POPUP_BACKGROUND2_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onTextChatBackground2ColorClose}
                            onChange={this.onTextChatBackground2ColorChange}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <ColorPickerOption
                            tooltipId="headerFontColorSettings"
                            tooltip="Sets the bottom color for the text chat background gradient"
                            label={`Background gradient color (${bg2InfoLabel})`}
                            disableAlpha={true}
                            color={this.state[TEXT_CHAT_POPUP_BACKGROUND_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onTextChatBackgroundColorClose}
                            onChange={this.onTextChatBackgroundColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />



                        {platform === 'web' && <>

                            <SwitcherOption
                                tooltipId="textChatOpenByDefaultSettings"
                                tooltip="Set border for text chat"
                                onClick={this.setBorderForChatSettings}
                                value={this.state[TEXT_CHAT_POPUP_HAS_BORDER_KEY]}
                                label="With border"
                            />


                            <ColorPickerOption
                                tooltipId="headerFontColorSettings"
                                tooltip="Sets the border color for text chat"
                                label="Border color"
                                className={this.state[TEXT_CHAT_POPUP_HAS_BORDER_KEY] ? '' : 'disabled'}
                                color={this.state[TEXT_CHAT_POPUP_BORDER_COLOR_KEY]}
                                horizontalPosition={ColorPickerHorizontalPosition.Right}
                                onClose={this.onChatBorderColorClose}
                                onChange={this.onChatBorderColorChange}
                                containerRef={this.optionsContainerRef}
                                verticalPosition={ColorPickerVerticalPosition.Smart}
                            />

                            <InputOption
                                tooltipId="popupTopPaddingSettings"
                                tooltip="Sets the top padding (in a range 0px - 40px)"
                                label="Top padding"
                                value={this.state[TEXT_CHAT_POPUP_PADDING_TOP_KEY]}
                                onValidate={this.validatePopupPaddingValue}
                                onBeforeValidate={this.validateNumberInput}
                                onConfirm={this.onPopupPaddingTopHeightChange}
                                prefix="px"
                            />

                            <InputOption
                                tooltipId="popupRightPaddingSettings"
                                tooltip="Sets the right padding (in a range 0px - 40px)"
                                label="Right padding"
                                value={this.state[TEXT_CHAT_POPUP_PADDING_RIGHT_KEY]}
                                onValidate={this.validatePopupPaddingValue}
                                onBeforeValidate={this.validateNumberInput}
                                onConfirm={this.onPopupPaddingRightHeightChange}
                                prefix="px"
                            />

                            <InputOption
                                tooltipId="popupBottomPaddingSettings"
                                tooltip="Sets the bottom padding (in a range 0px - 40px). Note: even with a value of 0, some space remains due to reserved gaps between bubbles."
                                label="Bottom padding"
                                value={this.state[TEXT_CHAT_POPUP_PADDING_BOTTOM_KEY]}
                                onValidate={this.validatePopupPaddingValue}
                                onBeforeValidate={this.validateNumberInput}
                                onConfirm={this.onPopupPaddingBottomHeightChange}
                                prefix="px"
                            />

                            <InputOption
                                tooltipId="popupLeftPaddingSettings"
                                tooltip="Sets the left padding (in a range 0px - 40px)"
                                label="Left padding"
                                value={this.state[TEXT_CHAT_POPUP_PADDING_LEFT_KEY]}
                                onValidate={this.validatePopupPaddingValue}
                                onBeforeValidate={this.validateNumberInput}
                                onConfirm={this.onPopupPaddingLeftHeightChange}
                                prefix="px"
                            />

                            <InputOption
                                prefix="px"
                                tooltipId="requestFontSizeSettings"
                                tooltip="Sets the border radius for the top left text chat corner (in a range 0px - 30px)"
                                label="Top left border radius"
                                value={this.state[TEXT_CHAT_POPUP_BORDER_RADIUS_TOP_LEFT_KEY]}
                                onValidate={this.validateBorderRadiusSizeValue}
                                onBeforeValidate={this.validateNumberInput}
                                onConfirm={this.onTopLeftBorderRadiusTextChatChanged}
                            />

                            <InputOption
                                prefix="px"
                                tooltipId="requestFontSizeSettings"
                                tooltip="Sets the border radius for the top right text chat corner (in a range 0px - 30px)"
                                label="Top right border radius"
                                value={this.state[TEXT_CHAT_POPUP_BORDER_RADIUS_TOP_RIGHT_KEY]}
                                onValidate={this.validateBorderRadiusSizeValue}
                                onBeforeValidate={this.validateNumberInput}
                                onConfirm={this.onTopRightBorderRadiusTextChatChanged}
                            />

                            <InputOption
                                prefix="px"
                                tooltipId="requestFontSizeSettings"
                                tooltip="Sets the border radius for the bottom right text chat corner (in a range 0px - 30px)"
                                label="Bottom right border radius"
                                value={this.state[TEXT_CHAT_POPUP_BORDER_RADIUS_BOTTOM_RIGHT_KEY]}
                                onValidate={this.validateBorderRadiusSizeValue}
                                onBeforeValidate={this.validateNumberInput}
                                onConfirm={this.onBottomRightBorderRadiusTextChatChanged}
                            />


                            <InputOption
                                prefix="px"
                                tooltipId="requestFontSizeSettings"
                                tooltip="Sets the border radius for the bottom left text chat corner (in a range 0px - 30px)"
                                label="Bottom left border radius"
                                value={this.state[TEXT_CHAT_POPUP_BORDER_RADIUS_BOTTOM_LEFT_KEY]}
                                onValidate={this.validateBorderRadiusSizeValue}
                                onBeforeValidate={this.validateNumberInput}
                                onConfirm={this.onBottomLeftBorderRadiusTextChatChanged}
                            />

                        </>}
                        {platform === 'web' && <React.Fragment>

                            <InputOption
                                prefix="px"
                                tooltipId="alanButtonTextChatMinHeightSettings"
                                tooltip="Sets the text chat min. height (in a range 160px - 1000px)"
                                label="Text chat min. height"
                                value={this.state[TEXT_CHAT_POPUP_MIN_HEIGHT_KEY]}
                                onValidate={this.onMinHeightValidate}
                                onBeforeValidate={this.validateNumberInput}
                                onConfirm={this.onMinHeightChatChange}
                            />


                            <InputOption
                                prefix="px"
                                tooltipId="alanButtonTextChatMinHeightSettings"
                                tooltip="Sets the text chat height (in a range 400px - 1200px)"
                                label="Text chat height"
                                value={this.state[TEXT_CHAT_POPUP_HEIGHT_KEY]}
                                onValidate={this.onHeightValidate}
                                onBeforeValidate={this.validateNumberInput}
                                onConfirm={this.onHeightChatChange}
                            />

                            <InputOption
                                tooltipId="alanButtonTextChatMinHeightSettings"
                                tooltip="Sets the text chat max. height (600px - 5000px or empty string)"
                                label="Text chat max. height"
                                value={this.state[TEXT_CHAT_POPUP_MAX_HEIGHT_KEY]}
                                onValidate={this.onMaxHeightValidate}
                                onBeforeValidate={this.validateNumberInput}
                                onConfirm={this.onMaxHeightChatChange}
                                prefix="px"
                            />

                            <InputOption
                                tooltipId="alanButtonTextChatWidthSettings"
                                tooltip="Sets the text chat min. width (in a range 250px - 1000px)"
                                label="Text chat min. width"
                                value={this.state[TEXT_CHAT_POPUP_MIN_WIDTH_KEY]}
                                onValidate={this.onMinWidthValidate}
                                onBeforeValidate={this.validateNumberInput}
                                onConfirm={this.onMinWidthChatChange}
                                prefix="px"
                            />


                            <InputOption
                                tooltipId="alanButtonTextChatWidthSettings"
                                tooltip="Sets the text chat width (in a range 250px - 4000px)"
                                label="Text chat width"
                                value={this.state[TEXT_CHAT_POPUP_WIDTH_KEY]}
                                onValidate={this.onWidthValidate}
                                onBeforeValidate={this.validateNumberInput}
                                onConfirm={this.onWidthChatChange}
                                prefix="px"
                            />


                            <InputOption
                                tooltipId="alanButtonTextChatMinHeightSettings"
                                tooltip="Sets the text chat max. width (in a range 250px - 4000px)"
                                label="Text chat max. width"
                                value={this.state[TEXT_CHAT_POPUP_MAX_WIDTH_KEY]}
                                onValidate={this.onMaxWidthValidate}
                                onBeforeValidate={this.validateNumberInput}
                                onConfirm={this.onMaxWidthChatChange}
                                prefix="px"
                            />

                        </React.Fragment>}
                        {platform === 'web' && <React.Fragment>
                            <div className="text-chat-options_table_row" style={{
                                minHeight: '188px',
                                maxHeight: '188px',
                                height: '188px',
                                paddingTop: '6px',
                                justifyContent: 'flex-start'
                            }}>
                                <div
                                    className={`text-chat-options_two-parts-holder `}>
                                    <span className="text-chat-options_label"
                                        data-place="bottom"
                                        data-multiline="true"
                                        data-effect="solid"
                                        data-offset="{'top': -20}"
                                        data-class="tutor-light-tooltip tutor-no-arrow-tooltip tutor-light-tooltip-240 text-chat-option-tooltip"
                                        fata-for="headerLabelSettings"
                                        data-tip="Sets the header label for the text chat">Font</span>


                                    <div className="text-chat-options_input-wrapper">
                                        <AutoComplete
                                            minQueryLength={-1}
                                            height="32px"
                                            key={`${fontFamily}-${fontFamilyUpdateTs}`}
                                            value={fontFamily}
                                            searchIcon={false}
                                            allowCustomText={true}
                                            searchLabel=""
                                            maxItemsLimit={39}
                                            inputClassName="no-hover"
                                            searchMoreTooltip={'Search to see more results'}
                                            onSearch={this.searchByFonts}
                                            onSelect={this.onFontSelect}
                                            placeholder="Select font..."
                                        />
                                    </div>
                                    <ReactTooltip id="headerLabelSettings" />
                                </div>
                                {(fontFamily && webSafeFonts.indexOf(fontFamily) === -1) &&
                                    <div className={`text-chat-options_input-wrapper-tooltip `}>
                                        <i className="icon icon-alan-info-sign" />If you choose to use a Google Font, make sure it is properly added to your website. <span className="text-chat-options_copy-tooltip" onClick={() => {
                                            copyTextToBuffer(`<link href="https://fonts.googleapis.com/css?family=${fontFamily}" rel="stylesheet">`);
                                            ToasterService.showInfo({ title: 'Font was copied' });
                                        }}>Copy a link tag<i className="icon icon-alan-test-copy" /></span> for the Google font and add it to your website.
                                        <br />
                                        If you choose to use a custom font, specify the font family and a fallback font (such as "Clarity City, sans-serif") in the field above. Add the custom font to your page using the CSS @font-face rule.
                                        Click <a target="_blank"
                                            rel="noreferrer"
                                            href={`${menuItems.docs.href}/usage/button/chat/#chat-ui-settings`}>here</a> for details </div>}

                            </div>
                        </React.Fragment>}


                        <div className={`text-chat-options_group-name  `}>Header</div>
                        <InputOption
                            tooltipId="headerLabelSettings"
                            tooltip="Sets the header label for the text chat"
                            label="Chat name"
                            value={this.state[TEXT_CHAT_HEADER_LABEL_KEY]}
                            onValidate={this.onChatNameValidate}
                            onConfirm={this.onSaveHeaderLabel}
                        />

                        <SvgIconOption
                            value={this.state[TEXT_CHAT_HEADER_LABEL_ICON_KEY]}
                            tooltipId="customHeaderLabelIconSettings"
                            tooltip="Sets the custom icon for header label "
                            label="Header icon"
                            onReset={this.onHeaderIconSvgReset}
                            onChange={this.onHeaderIconSvgChange}
                            iconWidth={24}
                            iconHeight={24}
                        />

                        <InputOption
                            tooltipId="headerIconGapSettings"
                            tooltip="Sets the gap between header logo and label"
                            label="Gap"
                            value={this.state[TEXT_CHAT_HEADER_LABEL_ICON_GAP_KEY]}
                            onValidate={this.validateHeaderIconGapValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onHeaderIconGapChange}
                            prefix="px"
                            className={!this.state[TEXT_CHAT_HEADER_LABEL_ICON_KEY] ? 'disabled' : ''}
                        />

                        <ComboBoxOption
                            tooltipId="headerElementsAlignment"
                            tooltip="Set vertical alignment for logo and label"
                            label="Vertical alignment"
                            values={verticalAlignments}
                            value={this.state[TEXT_CHAT_HEADER_LABEL_ALIGNMENT_KEY]}
                            onChange={this.onHeaderLogoLabelAlignmentChange}
                        />

                        <ComboBoxOption
                            tooltipId="headerLayoutName"
                            tooltip="Set layout type for chat's header"
                            label="Layout"
                            values={headerLayoutTypes}
                            value={this.state[TEXT_CHAT_HEADER_LAYOUT_NAME_KEY]}
                            onChange={this.onHeaderLayoutNameChange}
                        />

                        <InputOption
                            tooltipId="headerHeightSettings"
                            tooltip="Sets the header height (in a range 30px - 80px)"
                            label="Height"
                            value={this.state[TEXT_CHAT_HEADER_HEIGHT_KEY]}
                            onValidate={this.validateHeaderHeightValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onHeaderHeightChange}
                            prefix="px"
                        />

                        <SwitcherOption
                            tooltipId="textChatHeaderWithBottomGradientSettings"
                            tooltip="Add smoth gradient for messages that go outside of the scrolling area"
                            onClick={this.setHeaderWithBottomGradientSettings}
                            value={this.state[TEXT_CHAT_HEADER_WITH_BOTTOM_GRADIENT_KEY]}
                            label="With gradient on bottom border"
                        />

                        <InputOption
                            tooltipId="headerFontSizeSettings"
                            tooltip="Sets the header font size (in a range 10px - 22px)"
                            label="Font size"
                            value={this.state[TEXT_CHAT_HEADER_FONT_SIZE_KEY]}
                            onValidate={this.validateFontSizeValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onFontSizeHeaderChange}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="headerTopPaddingSettings"
                            tooltip="Sets the top padding (in a range 0px - 40px)"
                            label="Top padding"
                            value={this.state[TEXT_CHAT_HEADER_PADDING_TOP_KEY]}
                            onValidate={this.validateHeaderPaddingValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onHeaderPaddingTopHeightChange}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="headerRightPaddingSettings"
                            tooltip="Sets the right padding (in a range 0px - 40px)"
                            label="Right padding"
                            value={this.state[TEXT_CHAT_HEADER_PADDING_RIGHT_KEY]}
                            onValidate={this.validateHeaderPaddingValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onHeaderPaddingRightHeightChange}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="headerBottomPaddingSettings"
                            tooltip="Sets the bottom padding (in a range 0px - 40px)"
                            label="Bottom padding"
                            value={this.state[TEXT_CHAT_HEADER_PADDING_BOTTOM_KEY]}
                            onValidate={this.validateHeaderPaddingValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onHeaderPaddingBottomHeightChange}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="headerLeftPaddingSettings"
                            tooltip="Sets the left padding (in a range 0px - 40px)"
                            label="Left padding"
                            value={this.state[TEXT_CHAT_HEADER_PADDING_LEFT_KEY]}
                            onValidate={this.validateHeaderPaddingValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onHeaderPaddingLeftHeightChange}
                            prefix="px"
                        />


                        <ColorPickerOption
                            tooltipId="headerFontColorSettings"
                            tooltip="Sets the header font color"
                            label="Font color"
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onHeaderFontColorClose}
                            onChange={this.onHeaderFontColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                            color={this.state[TEXT_CHAT_HEADER_FONT_COLOR_KEY]}

                        />

                        <ColorPickerOption
                            tooltipId="headerFontColorSettings"
                            tooltip="Sets the header background color"
                            label="Background color"
                            disableAlpha={true}
                            color={this.state[TEXT_CHAT_HEADER_BACKGROUND_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onHeaderBackgroundColorClose}
                            onChange={this.onHeaderBackgroundColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <ColorPickerOption
                            tooltipId="headerFontColorSettings"
                            tooltip="Sets the background color for close icon"
                            label="Close icon color"
                            color={this.state[TEXT_CHAT_CLOSE_ICON_FILL_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onCloseIconBackgroundColorClose}
                            onChange={this.onCloseIconBackgroundColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <ColorPickerOption
                            tooltipId="headerFontColorSettings"
                            tooltip="Sets the background color for close icon in active state"
                            label="Close icon color (hovered)"
                            color={this.state[TEXT_CHAT_CLOSE_ICON_HOVER_FILL_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onCloseIconOnHoverBackgroundColorClose}
                            onChange={this.onCloseIconOnHoverBackgroundColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <SvgIconOption
                            value={this.state[TEXT_CHAT_CLOSE_ICON_KEY]}
                            tooltipId="customCloseIconSettings"
                            tooltip="Sets the custom icon for the close icon. "
                            label="Close icon"
                            onReset={this.onCloseIconSvgReset}
                            onChange={this.onCloseIconSvgChange}
                            iconWidth={24}
                            iconHeight={24}
                        />

                        {platform === 'web' &&
                            <SwitcherOption
                                label="Show Minimize Icon"
                                value={this.state[TEXT_CHAT_POPUP_MINIMIZE_MODE_ENABLED_KEY]}
                                onClick={this.setMinimizeModeSettings}
                                tooltip="Enable or disable the minimize icon for the text chat window."
                                tooltipId="textChatOpenByDefaultSettings"

                            />}

                        {this.state[TEXT_CHAT_POPUP_MINIMIZE_MODE_ENABLED_KEY] && <>
                            <ColorPickerOption
                                tooltipId="minimizeIconColorSettings"
                                tooltip="Sets the background color for minimize chat icon"
                                label="Minimize icon color"
                                color={this.state[TEXT_CHAT_MINIMIZE_ICON_FILL_COLOR_KEY]}
                                horizontalPosition={ColorPickerHorizontalPosition.Right}
                                onClose={this.onMinimizeIconBackgroundColorClose}
                                onChange={this.onMinimizeIconBackgroundColorChange}
                                containerRef={this.optionsContainerRef}
                                verticalPosition={ColorPickerVerticalPosition.Smart}
                            />

                            <ColorPickerOption
                                tooltipId="minimizeIconHoveredColorSettings"
                                tooltip="Sets the background color for minimize chat icon in active state"
                                label="Minimize icon color (hovered)"
                                color={this.state[TEXT_CHAT_MINIMIZE_ICON_HOVER_FILL_COLOR_KEY]}
                                horizontalPosition={ColorPickerHorizontalPosition.Right}
                                onClose={this.onMinimizeIconOnHoverBackgroundColorClose}
                                onChange={this.onMinimizeIconOnHoverBackgroundColorChange}
                                containerRef={this.optionsContainerRef}
                                verticalPosition={ColorPickerVerticalPosition.Smart}
                            />

                            <SvgIconOption
                                value={this.state[TEXT_CHAT_MINIMIZE_ICON_KEY]}
                                tooltipId="customMinimizeIconSettings"
                                tooltip="Sets the custom icon for the minimize chat icon. "
                                label="Minimize icon"
                                onReset={this.onMinimizeIconSvgReset}
                                onChange={this.onMinimizeIconSvgChange}
                                iconWidth={20}
                                iconHeight={20}
                            />
                        </>}

                        <ColorPickerOption
                            className={isAudioOutputIconVisible === false ? 'disabled' : ''}
                            tooltipId="headerFontColorSettings"
                            tooltip="Sets the background color for mute icon"
                            label="Audio output icon color"
                            color={this.state[TEXT_CHAT_MUTE_ICON_FILL_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onMuteIconBackgroundColorClose}
                            onChange={this.onMuteIconBackgroundColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <ColorPickerOption
                            className={isAudioOutputIconVisible === false ? 'disabled' : ''}
                            tooltipId="headerFontColorSettings"
                            tooltip="Sets the background color for mute icon in active state"
                            label="Audio output icon color (hovered)"
                            color={this.state[TEXT_CHAT_MUTE_ICON_HOVER_FILL_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onMuteIconOnHoverBackgroundColorClose}
                            onChange={this.onMuteIconOnHoverBackgroundColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <SvgIconOption
                            className={isAudioOutputIconVisible === false ? 'disabled' : ''}
                            value={this.state[TEXT_CHAT_UNMUTE_ICON_KEY]}
                            tooltipId="customUnmuteIconSettings"
                            tooltip="Sets the custom icon for audio output disabled"
                            label="Audio output enabled icon"
                            tooltipEndMsg="Click on the icon in preview area to see its state for audio output enabled/disabled mode"
                            onReset={this.onUnmuteIconSvgReset}
                            onChange={this.onUnmuteIconSvgChange}
                            iconWidth={20}
                            iconHeight={20}
                        />

                        <SvgIconOption
                            className={isAudioOutputIconVisible === false ? 'disabled' : ''}
                            value={this.state[TEXT_CHAT_MUTE_ICON_KEY]}
                            tooltipId="customMuteIconSettings"
                            tooltip="Sets the custom icon for audio output enabled"
                            label="Audio output disabled icon"
                            tooltipEndMsg="Click on the icon in preview area to see its state for audio output enabled/disabled mode"
                            onReset={this.onMuteIconSvgReset}
                            onChange={this.onMuteIconSvgChange}
                            iconWidth={20}
                            iconHeight={20}
                        />



                        {platform === 'web' &&
                            <>
                                <ColorPickerOption
                                    tooltipId="headerFontColorSettings"
                                    tooltip="Sets the color for full screen mode icon"
                                    label="Full screen mode icon color"
                                    color={this.state[TEXT_CHAT_EXPAND_COLLAPSE_ICON_FILL_COLOR_KEY]}
                                    horizontalPosition={ColorPickerHorizontalPosition.Right}
                                    onClose={this.onFullScreenIconColorrClose}
                                    onChange={this.onFullScreenIconColorChange}
                                    containerRef={this.optionsContainerRef}
                                    verticalPosition={ColorPickerVerticalPosition.Smart}
                                    className={fullScreenModeEnabled ? '' : 'disabled'}
                                />

                                <ColorPickerOption
                                    tooltipId="headerFontColorSettings"
                                    tooltip="Sets the color for full screen mode icon in active state"
                                    label="Full screen mode icon color (hovered)"
                                    color={this.state[TEXT_CHAT_EXPAND_COLLAPSE_ICON_HOVER_FILL_COLOR_KEY]}
                                    horizontalPosition={ColorPickerHorizontalPosition.Right}
                                    onClose={this.onFullScreenOnHoverColorClose}
                                    onChange={this.onFullScreenOnHoverColorChange}
                                    containerRef={this.optionsContainerRef}
                                    verticalPosition={ColorPickerVerticalPosition.Smart}
                                    className={fullScreenModeEnabled ? '' : 'disabled'}
                                />

                                <SvgIconOption
                                    value={this.state[TEXT_CHAT_POPUP_FULL_SCREEN_MODE_EXPAND_ICON_KEY]}
                                    tooltipId="customFullScreenExpandIconSettings"
                                    tooltip="Sets the custom icon for entering full screen mode"
                                    label="Enter full screen mode icon"
                                    onReset={this.onFullScreenModeExpandIconSvgReset}
                                    onChange={this.onFullScreenModeExpandIconSvgChange}
                                    tooltipEndMsg="Click on the icon in preview area to see its state for enter/exit full screen mode"
                                    iconWidth={20}
                                    iconHeight={20}
                                />

                                <SvgIconOption
                                    value={this.state[TEXT_CHAT_POPUP_FULL_SCREEN_MODE_COLLAPSE_ICON_KEY]}
                                    tooltipId="customFullScreenCollapseIconSettings"
                                    tooltip="Sets the custom icon for exiting full screen mode"
                                    label="Exit full screen mode icon"
                                    onReset={this.onFullScreenModeCollapseIconSvgReset}
                                    onChange={this.onFullScreenModeCollapseIconSvgChange}
                                    tooltipEndMsg="Click on the icon in preview area to see its state for enter/exit full screen mode"
                                    iconWidth={20}
                                    iconHeight={20}
                                />
                            </>}
                        {platform === 'web' &&
                            <>
                                <ColorPickerOption
                                    tooltipId="saveChatHistoryIconSettings"
                                    tooltip="Sets the color for the save chat history icon"
                                    label="Save chat history icon color"
                                    color={this.state[TEXT_CHAT_SAVE_TEXT_CHAT_STATE_ICON_FILL_COLOR_KEY]}
                                    horizontalPosition={ColorPickerHorizontalPosition.Right}
                                    onClose={this.onSaveChatStateIconColorrClose}
                                    onChange={this.onSaveChatStateIconColorChange}
                                    containerRef={this.optionsContainerRef}
                                    verticalPosition={ColorPickerVerticalPosition.Smart}
                                    className={saveChatStateEnabled ? '' : 'disabled'}
                                />

                                <ColorPickerOption
                                    tooltipId="saveChatHistoryIconHoveredSettings"
                                    tooltip="Sets the color for the save chat history icon in active state"
                                    label="Save chat history icon color (hovered)"
                                    color={this.state[TEXT_CHAT_SAVE_TEXT_CHAT_STATE_ICON_HOVER_FILL_COLOR_KEY]}
                                    horizontalPosition={ColorPickerHorizontalPosition.Right}
                                    onClose={this.onSaveChatStateOnHoverColorClose}
                                    onChange={this.onSaveChatStateOnHoverColorChange}
                                    containerRef={this.optionsContainerRef}
                                    verticalPosition={ColorPickerVerticalPosition.Smart}
                                    className={saveChatStateEnabled ? '' : 'disabled'}
                                />

                                <SvgIconOption
                                    value={this.state[TEXT_CHAT_SAVE_CHAT_STATE_ICON_KEY]}
                                    tooltipId="customSaveChatStateIconSettings"
                                    tooltip="Sets the custom icon for the save chat history icon. "
                                    label="Save chat history icon"
                                    onReset={this.onSaveChatStateIconSvgReset}
                                    onChange={this.onSaveChatStateIconSvgChange}
                                    iconWidth={20}
                                    iconHeight={20}
                                    className={saveChatStateEnabled ? '' : 'disabled'}
                                />
                            </>}

                        <div className={`text-chat-options_group-name  `}>Request bubble</div>

                        <InputOption
                            tooltipId="requestFontSizeSettings"
                            tooltip="Sets the font size for request text bubbles (in a range 10px - 22px)"
                            label="Font size"
                            value={this.state[TEXT_CHAT_BUBBLES_REQUEST_BFONT_SIZE_KEY]}
                            onValidate={this.validateFontSizeValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onFontSizeRequestChange}
                            prefix="px"
                        />

                        <ColorPickerOption
                            tooltipId="headerFontColorSettings"
                            tooltip="Sets the font color for request text bubbles"
                            label="Font color"
                            color={this.state[TEXT_CHAT_BUBBLES_REQUEST_FONT_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onRequestBubbleFontColorClose}
                            onChange={this.onRequestBubbleFontColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <ColorPickerOption
                            tooltipId="headerFontColorSettings"
                            tooltip="Sets the background color for request text bubbles"
                            label="Background color"
                            color={this.state[TEXT_CHAT_BUBBLES_REQUEST_BACKGROUND_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onRequestBubbleBackgroundColorClose}
                            onChange={this.onRequestBubbleBackgroundColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <ColorPickerOption
                            tooltipId="headerFontColorSettings"
                            tooltip="Sets the border color for request bubbles"
                            label="Border color"
                            color={this.state[TEXT_CHAT_BUBBLES_REQUEST_BORDER_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onRequestBubbleBorderColorClose}
                            onChange={this.onRequestBubbleBorderColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        {platform === 'web' &&
                            <SwitcherOption
                                tooltipId="textChatOpenByDefaultSettings"
                                tooltip="Add shadow for request bubles"
                                onClick={this.setShadowForRequestSettings}
                                value={this.state[TEXT_CHAT_BUBBLES_REQUEST_HAS_SHADOW_KEY]}
                                label="With shadow"
                            />}

                        <InputOption
                            tooltipId="requestBubbleTopPaddingSettings"
                            tooltip="Sets the top padding (in a range 0px - 40px)"
                            label="Top padding"
                            value={this.state[TEXT_CHAT_BUBBLES_REQUEST_PADDING_TOP_KEY]}
                            onValidate={this.validateBubblesPaddingValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onRequestBubblePaddingTopChange}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="requestBubbleRightPaddingSettings"
                            tooltip="Sets the right padding (in a range 0px - 40px)"
                            label="Right padding"
                            value={this.state[TEXT_CHAT_BUBBLES_REQUEST_PADDING_RIGHT_KEY]}
                            onValidate={this.validateBubblesPaddingValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onRequestBubblePaddingRightChange}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="requestBubbleBottomPaddingSettings"
                            tooltip="Sets the bottom padding (in a range 0px - 40px)"
                            label="Bottom padding"
                            value={this.state[TEXT_CHAT_BUBBLES_REQUEST_PADDING_BOTTOM_KEY]}
                            onValidate={this.validateBubblesPaddingValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onRequestBubblePaddingBottomChange}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="requestBubbleLeftPaddingSettings"
                            tooltip="Sets the left padding (in a range 0px - 40px)"
                            label="Left padding"
                            value={this.state[TEXT_CHAT_BUBBLES_REQUEST_PADDING_LEFT_KEY]}
                            onValidate={this.validateBubblesPaddingValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onRequestBubblePaddingLeftChange}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="requestFontSizeSettings"
                            tooltip="Sets the border radius for the top left request bubble corner (in a range 0px - 30px)"
                            label="Top left border radius"
                            value={this.state[TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_TOP_LEFT_KEY]}
                            onValidate={this.validateBorderRadiusSizeValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onRequestTopLeftBorderRadius}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="requestFontSizeSettings"
                            tooltip="Sets the border radius for the top right request bubble corner (in a range 0px - 30px)"
                            label="Top right border radius"
                            value={this.state[TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_TOP_RIGHT_KEY]}
                            onValidate={this.validateBorderRadiusSizeValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onRequestTopRightBorderRadius}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="requestFontSizeSettings"
                            tooltip="Sets the border radius for the bottom right request bubble corner (in a range 0px - 30px)"
                            label="Bottom right border radius"
                            value={this.state[TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_BOTTOM_RIGHT_KEY]}
                            onValidate={this.validateBorderRadiusSizeValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onRequestBottomRightBorderRadius}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="requestFontSizeSettings"
                            tooltip="Sets the border radius for the bottom left request bubble corner (in a range 0px - 30px)"
                            label="Bottom left border radius"
                            value={this.state[TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_BOTTOM_LEFT_KEY]}
                            onValidate={this.validateBorderRadiusSizeValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onRequestBottomLeftBorderRadius}
                            prefix="px"
                        />

                        <div className={`text-chat-options_group-name  `}>Request bubble label</div>

                        <SwitcherOption
                            tooltipId="requestLabelEnabledSettings"
                            tooltip="Add label for request bubles"
                            onClick={this.setBubbleLabelEnabledForRequest}
                            value={this.state[TEXT_CHAT_BUBBLES_REQUEST_LABEL_ENABLED_KEY]}
                            label="With label"
                        />
                        <div className={!this.state[TEXT_CHAT_BUBBLES_REQUEST_LABEL_ENABLED_KEY] ? 'hidden' : ''}>
                            <InputOption
                                tooltipId="requestLabelSettings"
                                tooltip="Sets the label for request bubble"
                                label="Label"
                                value={this.state[TEXT_CHAT_BUBBLES_REQUEST_LABEL_TEXT_KEY]}
                                onValidate={this.onBubbleLabelValidate}
                                onConfirm={this.onRequestLabelSave}
                            />

                            <InputOption
                                tooltipId="requestLabelFontSizeSettings"
                                tooltip="Sets the font size for request bubbles label (in a range 10px - 22px)"
                                label="Font size"
                                value={this.state[TEXT_CHAT_BUBBLES_REQUEST_LABEL_FONT_SIZE_KEY]}
                                onValidate={this.validateFontSizeValue}
                                onBeforeValidate={this.validateNumberInput}
                                onConfirm={this.onFontSizeRequestLabelChange}
                                prefix="px"
                            />

                            <ColorPickerOption
                                tooltipId="requestLabelFontColorSettings"
                                tooltip="Sets the font color for request bubbles label"
                                label="Font color"
                                color={this.state[TEXT_CHAT_BUBBLES_REQUEST_LABEL_FONT_COLOR_KEY]}
                                horizontalPosition={ColorPickerHorizontalPosition.Right}
                                onClose={this.onRequestBubbleLabelFontColorClose}
                                onChange={this.onRequestBubbleLabelFontColorChange}
                                containerRef={this.optionsContainerRef}
                                verticalPosition={ColorPickerVerticalPosition.Smart}
                            />

                            <InputOption
                                tooltipId="requestBubbleLabelTopPaddingSettings"
                                tooltip="Sets the top padding (in a range 0px - 40px)"
                                label="Top padding"
                                value={this.state[TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_TOP_KEY]}
                                onValidate={this.validateBubblesLabelPaddingValue}
                                onBeforeValidate={this.validateNumberInput}
                                onConfirm={this.onRequestBubbleLabelPaddingTopChange}
                                prefix="px"
                            />

                            <InputOption
                                tooltipId="requestBubbleLabelRightPaddingSettings"
                                tooltip="Sets the right padding (in a range 0px - 40px)"
                                label="Right padding"
                                value={this.state[TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_RIGHT_KEY]}
                                onValidate={this.validateBubblesLabelPaddingValue}
                                onBeforeValidate={this.validateNumberInput}
                                onConfirm={this.onRequestBubbleLabelPaddingRightChange}
                                prefix="px"
                            />

                            <InputOption
                                tooltipId="requestBubbleLabelBottomPaddingSettings"
                                tooltip="Sets the bottom padding (in a range 0px - 40px)"
                                label="Bottom padding"
                                value={this.state[TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_BOTTOM_KEY]}
                                onValidate={this.validateBubblesLabelPaddingValue}
                                onBeforeValidate={this.validateNumberInput}
                                onConfirm={this.onRequestBubbleLabelPaddingBottomChange}
                                prefix="px"
                            />

                            <InputOption
                                tooltipId="requestBubbleLabelLeftPaddingSettings"
                                tooltip="Sets the left padding (in a range 0px - 40px)"
                                label="Left padding"
                                value={this.state[TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_LEFT_KEY]}
                                onValidate={this.validateBubblesLabelPaddingValue}
                                onBeforeValidate={this.validateNumberInput}
                                onConfirm={this.onRequestBubbleLabelPaddingLeftChange}
                                prefix="px"
                            />

                        </div>

                        <div className={`text-chat-options_group-name  `}>Response bubble</div>

                        <InputOption
                            tooltipId="responseFontSizeSettings"
                            tooltip="Sets the font size for response text bubbles (in a range 10px - 22px)"
                            label="Font size"
                            value={this.state[TEXT_CHAT_BUBBLES_RESPONSE_FONT_SIZE_KEY]}
                            onValidate={this.validateFontSizeValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onResponseFontSizeChange}
                            prefix="px"
                        />

                        <ColorPickerOption
                            tooltipId="headerFontColorSettings"
                            tooltip="Sets the font color for response text bubbles"
                            label="Font color"
                            color={this.state[TEXT_CHAT_BUBBLES_RESPONSE_FONT_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onResponseBubbleFontColorClose}
                            onChange={this.onResponseBubbleFontColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <ColorPickerOption
                            tooltipId="headerFontColorSettings"
                            tooltip="Sets the background color for response text bubbles"
                            label="Background color"
                            color={this.state[TEXT_CHAT_BUBBLES_RESPONSE_BACKGROUND_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onResponseBubbleBackgroundColorClose}
                            onChange={this.onResponseBubbleBackgroundColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <ColorPickerOption
                            tooltipId="headerFontColorSettings"
                            tooltip="Sets the border color for response bubbles"
                            label="Border color"
                            color={this.state[TEXT_CHAT_BUBBLES_RESPONSE_BORDER_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onResponseBubbleBorderColorClose}
                            onChange={this.onResponseBubbleBorderColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        {platform === 'web' &&
                            <SwitcherOption
                                tooltipId="textChatOpenByDefaultSettings"
                                tooltip="Add shadow for response bubles"
                                onClick={this.setShadowForResponsesSettings}
                                value={this.state[TEXT_CHAT_BUBBLES_RESPONSE_HAS_SHADOW_KEY]}
                                label="With shadow"
                            />
                        }

                        <InputOption
                            tooltipId="responseBubbleTopPaddingSettings"
                            tooltip="Sets the top padding (in a range 0px - 40px)"
                            label="Top padding"
                            value={this.state[TEXT_CHAT_BUBBLES_RESPONSE_PADDING_TOP_KEY]}
                            onValidate={this.validateBubblesPaddingValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onResponseBubblePaddingTopChange}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="responseBubbleRightPaddingSettings"
                            tooltip="Sets the right padding (in a range 0px - 40px)"
                            label="Right padding"
                            value={this.state[TEXT_CHAT_BUBBLES_RESPONSE_PADDING_RIGHT_KEY]}
                            onValidate={this.validateBubblesPaddingValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onResponseBubblePaddingRightChange}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="responseBubbleBottomPaddingSettings"
                            tooltip="Sets the bottom padding (in a range 0px - 40px)"
                            label="Bottom padding"
                            value={this.state[TEXT_CHAT_BUBBLES_RESPONSE_PADDING_BOTTOM_KEY]}
                            onValidate={this.validateBubblesPaddingValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onResponseBubblePaddingBottomChange}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="responseBubbleLeftPaddingSettings"
                            tooltip="Sets the left padding (in a range 0px - 40px)"
                            label="Left padding"
                            value={this.state[TEXT_CHAT_BUBBLES_RESPONSE_PADDING_LEFT_KEY]}
                            onValidate={this.validateBubblesPaddingValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onResponseBubblePaddingLeftChange}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="requestFontSizeSettings"
                            tooltip="Sets the border radius for the top left response bubble corner (in a range 0px - 30px)"
                            label="Top left border radius"
                            value={this.state[TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_TOP_LEFT_KEY]}
                            onValidate={this.validateBorderRadiusSizeValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onResponseTopLeftBorderRadius}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="requestFontSizeSettings"
                            tooltip="Sets the border radius for the top right response bubble corner (in a range 0px - 30px)"
                            label="Top right border radius"
                            value={this.state[TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_TOP_RIGHT_KEY]}
                            onValidate={this.validateBorderRadiusSizeValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onResponseTopRightBorderRadius}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="requestFontSizeSettings"
                            tooltip="Sets the border radius for the bottom right response bubble corner (in a range 0px - 30px)"
                            label="Bottom right border radius"
                            value={this.state[TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_BOTTOM_RIGHT_KEY]}
                            onValidate={this.validateBorderRadiusSizeValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onResponseBottomRightBorderRadius}
                            prefix="px"
                        />


                        <InputOption
                            tooltipId="requestFontSizeSettings"
                            tooltip="Sets the border radius for the bottom left response bubble corner (in a range 0px - 30px)"
                            label="Bottom left border radius"
                            value={this.state[TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_BOTTOM_LEFT_KEY]}
                            onValidate={this.validateBorderRadiusSizeValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onResponseBottomLeftBorderRadius}
                            prefix="px"
                        />

                        {platform === 'web' &&
                            <>
                                <SwitcherOption
                                    tooltipId="textChatOpenByDefaultSettings"
                                    tooltip="Add ability to copy responses's text"
                                    label="Add copy button for response bubbles"
                                    onClick={this.setCopyBtnForResponsesSettings}
                                    value={isCopyBtnActive}
                                />
                                <SwitcherOption
                                    tooltipId="textChatOpenByDefaultSettings"
                                    tooltip="Add ability to like responses"
                                    label="Add like button for response bubbles"
                                    onClick={this.setLikeBtnForResponsesSettings}
                                    value={isFeedbackBtnsActive}
                                />

                                <div className={(isCopyBtnActive || isFeedbackBtnsActive) ? '' : 'disabled'}>
                                    <ColorPickerOption
                                        tooltipId="bottomBtnsColorSettings"
                                        tooltip="Sets the color for copy, like and dislike controls"
                                        label="Copy, Like, Dislike buttons color"
                                        color={this.state[TEXT_CHAT_BUBBLES_RESPONSE_BOTTOM_BTNS_COLOR_KEY]}
                                        horizontalPosition={ColorPickerHorizontalPosition.Right}
                                        onClose={this.onResponseBubbleBottomBtnsColorClose}
                                        onChange={this.onResponseBubbleBottomBtnsColorChange}
                                        containerRef={this.optionsContainerRef}
                                        verticalPosition={ColorPickerVerticalPosition.Smart}
                                    />

                                    <ColorPickerOption
                                        tooltipId="bottomBtnsBackgroundHoveredColorSettings"
                                        tooltip="Sets the background color for copy, like and dislike controls (hovered state)"
                                        label="Copy, Like, Dislike buttons background (hovered)"
                                        color={this.state[TEXT_CHAT_BUBBLES_RESPONSE_BOTTOM_BTNS_BACKGROUND_HOVERED_KEY]}
                                        horizontalPosition={ColorPickerHorizontalPosition.Right}
                                        onClose={this.onResponseBubbleBottomBtnsBackgroundHoverColorClose}
                                        onChange={this.onResponseBubbleBottomBtnsBackgroundHoverColorChange}
                                        containerRef={this.optionsContainerRef}
                                        verticalPosition={ColorPickerVerticalPosition.Smart}
                                    />
                                </div>

                                <div className={`text-chat-options_group-name  `}>Response bubble label</div>

                                <SwitcherOption
                                    tooltipId="responseLabelEnabledSettings"
                                    tooltip="Add label for response bubles"
                                    onClick={this.setBubbleLabelEnabledForResponse}
                                    value={this.state[TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ENABLED_KEY]}
                                    label="With label"
                                />

                                <div className={!this.state[TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ENABLED_KEY] ? 'hidden' : ''}>
                                    <InputOption
                                        tooltipId="responseLabelSettings"
                                        tooltip="Sets the label for response bubbles"
                                        label="Label"
                                        value={this.state[TEXT_CHAT_BUBBLES_RESPONSE_LABEL_TEXT_KEY]}
                                        onValidate={this.onBubbleLabelValidate}
                                        onConfirm={this.onResponseLabelSave}
                                    />

                                    <SvgIconOption
                                        value={this.state[TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ICON_KEY]}
                                        tooltipId="customResponseBubbleLabelIconSettings"
                                        tooltip="Sets the custom icon for the response bubble label"
                                        label="Icon"
                                        onReset={this.onResponseLabelIconSvgReset}
                                        onChange={this.onResponseLabelIconSvgChange}
                                        iconWidth={24}
                                        iconHeight={24}
                                    />

                                    <InputOption
                                        tooltipId="headerIconGapSettings"
                                        tooltip="Sets the gap between header logo and label"
                                        label="Gap"
                                        value={this.state[TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ICON_GAP_KEY]}
                                        onValidate={this.validateResponseLabelIconGapValue}
                                        onBeforeValidate={this.validateNumberInput}
                                        onConfirm={this.onResponseLabelIconGapChange}
                                        prefix="px"
                                        className={!this.state[TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ICON_KEY] ? 'disabled' : ''}
                                    />

                                    <ComboBoxOption
                                        tooltipId="responseBubbleLabelElementsAlignment"
                                        tooltip="Set vertical alignment for logo and label"
                                        label="Vertical alignment"
                                        values={verticalAlignments}
                                        value={this.state[TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ALIGNMENT_KEY]}
                                        onChange={this.onResponseBubbleLogoLabelAlignmentChange}
                                    />


                                    <InputOption
                                        tooltipId="responseLabelFontSizeSettings"
                                        tooltip="Sets the font size for response bubbles label (in a range 10px - 22px)"
                                        label="Font size"
                                        value={this.state[TEXT_CHAT_BUBBLES_RESPONSE_LABEL_FONT_SIZE_KEY]}
                                        onValidate={this.validateFontSizeValue}
                                        onBeforeValidate={this.validateNumberInput}
                                        onConfirm={this.onFontSizeResponseLabelChange}
                                        prefix="px"
                                    />

                                    <ColorPickerOption
                                        tooltipId="responseLabelFontColorSettings"
                                        tooltip="Sets the font color for response bubbles label"
                                        label="Font color"
                                        color={this.state[TEXT_CHAT_BUBBLES_RESPONSE_LABEL_FONT_COLOR_KEY]}
                                        horizontalPosition={ColorPickerHorizontalPosition.Right}
                                        onClose={this.onResponseBubbleLabelFontColorClose}
                                        onChange={this.onResponseBubbleLabelFontColorChange}
                                        containerRef={this.optionsContainerRef}
                                        verticalPosition={ColorPickerVerticalPosition.Smart}
                                    />

                                    <InputOption
                                        tooltipId="responseBubbleLabelTopPaddingSettings"
                                        tooltip="Sets the top padding (in a range 0px - 40px)"
                                        label="Top padding"
                                        value={this.state[TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_TOP_KEY]}
                                        onValidate={this.validateBubblesLabelPaddingValue}
                                        onBeforeValidate={this.validateNumberInput}
                                        onConfirm={this.onResponseBubbleLabelPaddingTopChange}
                                        prefix="px"
                                    />

                                    <InputOption
                                        tooltipId="responseBubbleLabelRightPaddingSettings"
                                        tooltip="Sets the right padding (in a range 0px - 40px)"
                                        label="Right padding"
                                        value={this.state[TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_RIGHT_KEY]}
                                        onValidate={this.validateBubblesLabelPaddingValue}
                                        onBeforeValidate={this.validateNumberInput}
                                        onConfirm={this.onResponseBubbleLabelPaddingRightChange}
                                        prefix="px"
                                    />

                                    <InputOption
                                        tooltipId="responseBubbleLabelBottomPaddingSettings"
                                        tooltip="Sets the bottom padding (in a range 0px - 40px)"
                                        label="Bottom padding"
                                        value={this.state[TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_BOTTOM_KEY]}
                                        onValidate={this.validateBubblesLabelPaddingValue}
                                        onBeforeValidate={this.validateNumberInput}
                                        onConfirm={this.onResponseBubbleLabelPaddingBottomChange}
                                        prefix="px"
                                    />

                                    <InputOption
                                        tooltipId="responseBubbleLabelLeftPaddingSettings"
                                        tooltip="Sets the left padding (in a range 0px - 40px)"
                                        label="Left padding"
                                        value={this.state[TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_LEFT_KEY]}
                                        onValidate={this.validateBubblesLabelPaddingValue}
                                        onBeforeValidate={this.validateNumberInput}
                                        onConfirm={this.onResponseBubbleLabelPaddingLeftChange}
                                        prefix="px"
                                    />
                                </div>

                                <div className={`text-chat-options_group-name  `}>Response waiting message</div>

                                <ComboBoxOption
                                    tooltipId="waitingBubbleLayoutNameSettings"
                                    tooltip="Configures the layout for the response waiting bubble. If you choose a non-default layout, make sure to select a loader icon. Otherwise, only the label will be displayed in the response waiting bubble."
                                    label="Layout"
                                    width="280px"
                                    values={waitingResponseLayoutTypes}
                                    value={waitingResponseBubbleLayout}
                                    onChange={this.onWaitingBubbleLayoutNameChange}
                                />

                                <SwitcherOption
                                    tooltipId="textChatQueryProgessEnabledSettings"
                                    tooltip="Enable dynamic status updates for the response waiting bubble."
                                    label="Enable dynamic status updates"
                                    onClick={this.onQueryProgressEnabledChange}
                                    value={this.state[TEXT_CHAT_BUBBLES_WAITING_RESPONSE_QUERY_PROGRESS_ENABLED_KEY]}
                                />

                                <div className={this.state[TEXT_CHAT_BUBBLES_WAITING_RESPONSE_QUERY_PROGRESS_ENABLED_KEY] ? 'disabled' : ''}>
                                    <InputOption
                                        tooltipId="waitingBubbleLabelSettings"
                                        tooltip="Sets the label text for response waiting bubble"
                                        label="Label"
                                        value={this.state[TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LABEL_KEY] || ''}
                                        onValidate={this.validateWaitingBubbleLabeL}
                                        onConfirm={this.onWaitingBubbleLabelChange}
                                    />
                                </div>

                                <SvgIconOption
                                    value={this.state[TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LOADER_ICON_KEY]}
                                    tooltipId="waitingBubbleLoaderIconSettings"
                                    tooltip="Sets the custom icon in response waiting bubble"
                                    label="Loader icon"
                                    onReset={this.onLoaderIconSvgReset}
                                    onChange={this.onLoaderIconSvgChange}
                                    iconWidth={24}
                                    iconHeight={24}
                                />

                                <ColorPickerOption
                                    tooltipId="customSendIconColorSettings"
                                    tooltip="Sets the color for the icon in response waiting bubble"
                                    label="Loader icon color"
                                    color={this.state[TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LOADER_ICON_DEFAULT_FILL_COLOR_KEY]}
                                    horizontalPosition={ColorPickerHorizontalPosition.Right}
                                    onClose={this.onStopResponseIconColorClose}
                                    onChange={this.onStopResponseIconColorChange}
                                    containerRef={this.optionsContainerRef}
                                    verticalPosition={ColorPickerVerticalPosition.Smart}
                                />

                                <ColorPickerOption
                                    tooltipId="customSendIconHoverColorSettings"
                                    tooltip="Sets the color for stop response button (hovered state)"
                                    label="Stop response icon color (hovered)"
                                    color={this.state[TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LOADER_ICON_HOVER_FILL_COLOR_KEY]}
                                    horizontalPosition={ColorPickerHorizontalPosition.Right}
                                    onClose={this.onStopResponseIconHoveredColorClose}
                                    onChange={this.onStopResponseIconHoveredColorChange}
                                    containerRef={this.optionsContainerRef}
                                    verticalPosition={ColorPickerVerticalPosition.Smart}
                                />

                                <InputOption
                                    tooltipId="waitingBubbleLoaderIconGaPSettings"
                                    tooltip="Sets the gap between icon and label"
                                    label="Gap"
                                    value={this.state[TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LABEL_ICON_GAP_KEY]}
                                    onValidate={this.validateLoaderIconGapValue}
                                    onBeforeValidate={this.validateNumberInput}
                                    onConfirm={this.onLoaderLabelIconGapChange}
                                    prefix="px"
                                />

                                <ComboBoxOption
                                    tooltipId="waitingBubbleElementsAlignment"
                                    tooltip="Set vertical alignment for the content of the response waiting bubble"
                                    label="Vertical alignment"
                                    values={verticalAlignments}
                                    value={this.state[TEXT_CHAT_BUBBLES_WAITING_RESPONSE_ALIGNMENT_KEY]}
                                    onChange={this.onWaitingResponseBubbleAlignmentChange}
                                />





                                <div className={`text-chat-options_group-name  `}>Links in text</div>

                                <ColorPickerOption
                                    tooltipId="linkFontColorSettings"
                                    tooltip="Sets the font color for links in text chat"
                                    label="Link color"
                                    color={this.state[TEXT_CHAT_BUBBLES_RESPONSE_LINK_FONT_COLOR_KEY]}
                                    horizontalPosition={ColorPickerHorizontalPosition.Right}
                                    onClose={this.onLinkColorClose}
                                    onChange={this.onLinkColorChange}
                                    containerRef={this.optionsContainerRef}
                                    verticalPosition={ColorPickerVerticalPosition.Smart}
                                />

                                <ColorPickerOption
                                    tooltipId="linkHoveredFontColorSettings"
                                    tooltip="Sets the font color for links in text chat (hovered state)"
                                    label="Link color (hovered)"
                                    color={this.state[TEXT_CHAT_BUBBLES_RESPONSE_LINK_HOVERED_FONT_COLOR_KEY]}
                                    horizontalPosition={ColorPickerHorizontalPosition.Right}
                                    onClose={this.onLinkHoveredColorClose}
                                    onChange={this.onLinkHoveredColorChange}
                                    containerRef={this.optionsContainerRef}
                                    verticalPosition={ColorPickerVerticalPosition.Smart}
                                />
                            </>

                        }

                        <div className={`text-chat-options_group-name  `}>Learn more links</div>

                        <InputOption
                            prefix="px"
                            tooltipId="learnMoreLinkBorderRadiusSettings"
                            tooltip="Sets the border radius for the top left link block corner (in a range 0px - 30px)"
                            label="Top left border radius"
                            value={this.state[TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_TOP_LEFT_KEY]}
                            onValidate={this.validateLearnMoreBorderRadiusSizeValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onTopLeftBorderRadiusLearnMoreLinkChanged}
                        />

                        <InputOption
                            prefix="px"
                            tooltipId="learnMoreLinkBorderRadiusSettings"
                            tooltip="Sets the border radius for the top right link block corner (in a range 0px - 30px)"
                            label="Top right border radius"
                            value={this.state[TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_TOP_RIGHT_KEY]}
                            onValidate={this.validateLearnMoreBorderRadiusSizeValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onTopRightBorderRadiusLearnMoreLinkChanged}
                        />

                        <InputOption
                            prefix="px"
                            tooltipId="learnMoreLinkBorderRadiusSettings"
                            tooltip="Sets the border radius for the bottom right link block corner (in a range 0px - 30px)"
                            label="Bottom right border radius"
                            value={this.state[TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_BOTTOM_RIGHT_KEY]}
                            onValidate={this.validateLearnMoreBorderRadiusSizeValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onBottomRightBorderRadiusLearnMoreLinkChanged}
                        />

                        <InputOption
                            prefix="px"
                            tooltipId="learnMoreLinkBorderRadiusSettings"
                            tooltip="Sets the border radius for the bottom left link block corner (in a range 0px - 30px)"
                            label="Bottom left border radius"
                            value={this.state[TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_BOTTOM_LEFT_KEY]}
                            onValidate={this.validateLearnMoreBorderRadiusSizeValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onBottomLeftBorderRadiusLearnMoreLinkChanged}
                        />
                        <ColorPickerOption
                            tooltipId="learnMoreLinkDefaultBorderColorSettings"
                            tooltip="Sets the border color for links in learn more sections in text chat"
                            label="Border color"
                            color={this.state[TEXT_CHAT_LEAR_MORE_LINKS_DEFAULT_BORDER_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onLearnMoreLinkBorderColorClose}
                            onChange={this.onLearnMoreLinkBorderColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <ColorPickerOption
                            tooltipId="learnMoreLinkHoverBorderColorSettings"
                            tooltip="Sets the border color for links in learn more sections in text chat (hovered state)"
                            label="Border color (hovered)"
                            color={this.state[TEXT_CHAT_LEAR_MORE_LINKS_HOVER_BORDER_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onLearnMoreLinkHoverBorderColorClose}
                            onChange={this.onLearnMoreLinkHoverBorderColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <ColorPickerOption
                            tooltipId="learnMoreLinkActiveBorderColorSettings"
                            tooltip="Sets the border color for links in learn more sections in text chat (clicked state)"
                            label="Border color (clicked)"
                            color={this.state[TEXT_CHAT_LEAR_MORE_LINKS_ACTIVE_BORDER_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onLearnMoreLinkActiveBorderColorClose}
                            onChange={this.onLearnMoreLinkActiveBorderColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />


                        <ColorPickerOption
                            tooltipId="learnMoreLinkDefaultlinkMainBackgroundColorSettings"
                            tooltip="Sets the background color for text part for links in learn more sections in text chat"
                            label="Text part background color"
                            color={this.state[TEXT_CHAT_LEAR_MORE_LINKS_LINK_DEFAULT_BACKGROUND_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onLearnMoreLinkBackgroundColorClose}
                            onChange={this.onLearnMoreLinkBackgroundColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <ColorPickerOption
                            tooltipId="learnMoreLinkHoverlinkMainBackgroundColorSettings"
                            tooltip="Sets the background color for text part for links in learn more sections in text chat (hovered state)"
                            label="Text part background color (hovered)"
                            color={this.state[TEXT_CHAT_LEAR_MORE_LINKS_LINK_HOVER_BACKGROUND_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onLearnMoreLinkHoverBackgroundColorClose}
                            onChange={this.onLearnMoreLinkHoverBackgroundColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <ColorPickerOption
                            tooltipId="learnMoreLinkActivelinkMainBackgroundColorSettings"
                            tooltip="Sets the background color for text part for links in learn more sections in text chat (clicked state)"
                            label="Text part background color (clicked)"
                            color={this.state[TEXT_CHAT_LEAR_MORE_LINKS_LINK_ACTIVE_BACKGROUND_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onLearnMoreLinkActiveBackgroundColorClose}
                            onChange={this.onLearnMoreLinkActiveBackgroundColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />


                        <ColorPickerOption
                            tooltipId="learnMoreLinkDefaultlinkNumberBackgroundColorSettings"
                            tooltip="Sets the background color for number part for links in learn more sections in text chat"
                            label="Number part background color"
                            color={this.state[TEXT_CHAT_LEAR_MORE_LINKS_LINK_NUMBER_DEFAULT_BACKGROUND_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onLearnMoreLinkLinkNumberBackgroundColorClose}
                            onChange={this.onLearnMoreLinkLinkNumberBackgroundColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <ColorPickerOption
                            tooltipId="learnMoreLinkHoverlinkNumberBackgroundColorSettings"
                            tooltip="Sets the background color for number part for links in learn more sections in text chat (hovered state)"
                            label="Number part background color (hovered)"
                            color={this.state[TEXT_CHAT_LEAR_MORE_LINKS_LINK_NUMBER_HOVER_BACKGROUND_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onLearnMoreLinkHoverLinkNumberBackgroundColorClose}
                            onChange={this.onLearnMoreLinkHoverLinkNumberBackgroundColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <ColorPickerOption
                            tooltipId="learnMoreLinkActivelinkNumberBackgroundColorSettings"
                            tooltip="Sets the background color for number part for links in learn more sections in text chat (clicked state)"
                            label="Number part background color (clicked)"
                            color={this.state[TEXT_CHAT_LEAR_MORE_LINKS_LINK_NUMBER_ACTIVE_BACKGROUND_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onLearnMoreLinkActiveLinkNumberBackgroundColorClose}
                            onChange={this.onLearnMoreLinkActiveLinkNumberBackgroundColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <div className={`text-chat-options_group-name  `}>Code</div>

                        <ColorPickerOption
                            tooltipId="codeBackgroundColorSettings"
                            tooltip="Sets the background color for code in response bubbles."
                            label="Background color"
                            color={this.state[TEXT_CHAT_BUBBLES_RESPONSE_CODE_BACKGROUND_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onResponseBubbleCodeBackgroundColorClose}
                            onChange={this.onResponseBubbleCodeBackgroundColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <ColorPickerOption
                            tooltipId="codeBorderColorSettings"
                            tooltip="Sets the border color for code in response bubbles."
                            label="Border color"
                            color={this.state[TEXT_CHAT_BUBBLES_RESPONSE_CODE_BORDER_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onResponseBubbleCodeBorderColorClose}
                            onChange={this.onResponseBubbleCodeBorderColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <ComboBoxOption
                            tooltipId="codeThemeSettings"
                            tooltip="Set theme for code in response bubbles."
                            label="Theme"
                            values={codeThemes}
                            value={this.state[TEXT_CHAT_BUBBLES_RESPONSE_CODE_THEME_KEY]}
                            onChange={this.onResponseBubbleCodeThemeChange}
                        />

                        <div className={`text-chat-options_group-name  `}>Tables</div>

                        <ColorPickerOption
                            tooltipId="taBleBorderColorSettings"
                            tooltip="Sets the border color for tables in responses"
                            label="Border color"
                            color={this.state[TEXT_CHAT_BUBBLES_RESPONSE_TABLE_BORDER_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onTableBorderColorClose}
                            onChange={this.onTableBorderColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />


                        <div className={`text-chat-options_group-name  `}>Context Divider</div>

                        <ColorPickerOption
                            tooltipId="newDialogSeparatorColorSettings"
                            tooltip="Sets the color of the separator that appears in the chat when context is lost due to a reconnect, indicating that the prior conversation history is no longer retained"
                            label="Color"
                            color={this.state[TEXT_CHAT_BUBBLES_NEW_DIALOG_SEPARATOR_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onNewDialogSeparatorColorClose}
                            onChange={this.onNewDialogSeparatorColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        {platform === 'web' &&
                            <>
                                <div className={`text-chat-options_group-name  `}>Buttons</div>

                                <InputOption
                                    tooltipId="responseFontSizeSettings"
                                    tooltip="Sets the font size for buttons in text chat (in a range 10px - 22px)"
                                    label="Font size"
                                    value={this.state[TEXT_CHAT_BUTTONS_FONT_SIZE_KEY]}
                                    onValidate={this.validateFontSizeValue}
                                    onBeforeValidate={this.validateNumberInput}
                                    onConfirm={this.onButtonsFontSizeChange}
                                    prefix="px"
                                />

                                <InputOption
                                    tooltipId="buttonsTopPaddingSettings"
                                    tooltip="Sets the top padding (in a range 0px - 40px)"
                                    label="Top padding"
                                    value={this.state[TEXT_CHAT_BUTTONS_PADDING_TOP_KEY]}
                                    onValidate={this.validateButtonsPaddingValue}
                                    onBeforeValidate={this.validateNumberInput}
                                    onConfirm={this.onButtonsPaddingTopHeightChange}
                                    prefix="px"
                                />

                                <InputOption
                                    tooltipId="buttonsRightPaddingSettings"
                                    tooltip="Sets the right padding (in a range 0px - 40px)"
                                    label="Right padding"
                                    value={this.state[TEXT_CHAT_BUTTONS_PADDING_RIGHT_KEY]}
                                    onValidate={this.validateButtonsPaddingValue}
                                    onBeforeValidate={this.validateNumberInput}
                                    onConfirm={this.onButtonsPaddingRightHeightChange}
                                    prefix="px"
                                />

                                <InputOption
                                    tooltipId="buttonsBottomPaddingSettings"
                                    tooltip="Sets the bottom padding (in a range 0px - 40px)"
                                    label="Bottom padding"
                                    value={this.state[TEXT_CHAT_BUTTONS_PADDING_BOTTOM_KEY]}
                                    onValidate={this.validateButtonsPaddingValue}
                                    onBeforeValidate={this.validateNumberInput}
                                    onConfirm={this.onButtonsPaddingBottomHeightChange}
                                    prefix="px"
                                />

                                <InputOption
                                    tooltipId="buttonsLeftPaddingSettings"
                                    tooltip="Sets the left padding (in a range 0px - 40px)"
                                    label="Left padding"
                                    value={this.state[TEXT_CHAT_BUTTONS_PADDING_LEFT_KEY]}
                                    onValidate={this.validateButtonsPaddingValue}
                                    onBeforeValidate={this.validateNumberInput}
                                    onConfirm={this.onButtonsPaddingLeftHeightChange}
                                    prefix="px"
                                />

                                <InputOption
                                    tooltipId="requestFontSizeSettings"
                                    tooltip="Sets the border radius for the top left button corner (in a range 0px - 30px)"
                                    label="Top left border radius"
                                    value={this.state[TEXT_CHAT_BUTTONS_BORDER_RADIUS_TOP_LEFT_KEY]}
                                    onValidate={this.validateBorderRadiusSizeValue}
                                    onBeforeValidate={this.validateNumberInput}
                                    onConfirm={this.onBtnsTopLeftBorderRadiusChange}
                                    prefix="px"
                                />

                                <InputOption
                                    tooltipId="requestFontSizeSettings"
                                    tooltip="Sets the border radius for the top right button corner (in a range 0px - 30px)"
                                    label="Top right border radius"
                                    value={this.state[TEXT_CHAT_BUTTONS_BORDER_RADIUS_TOP_RIGHT_KEY]}
                                    onValidate={this.validateBorderRadiusSizeValue}
                                    onBeforeValidate={this.validateNumberInput}
                                    onConfirm={this.onBtnsTopRightBorderRadiusChange}
                                    prefix="px"
                                />

                                <InputOption
                                    tooltipId="requestFontSizeSettings"
                                    tooltip="Sets the border radius for the bottom right button corner (in a range 0px - 30px)"
                                    label="Bottom right border radius"
                                    value={this.state[TEXT_CHAT_BUTTONS_BORDER_RADIUS_BOTTOM_RIGHT_KEY]}
                                    onValidate={this.validateBorderRadiusSizeValue}
                                    onBeforeValidate={this.validateNumberInput}
                                    onConfirm={this.onBtnsBottomRightBorderRadiusChange}
                                    prefix="px"
                                />

                                <InputOption
                                    tooltipId="requestFontSizeSettings"
                                    tooltip="Sets the border radius for the bottom left button corner (in a range 0px - 30px)"
                                    label="Bottom left border radius"
                                    value={this.state[TEXT_CHAT_BUTTONS_BORDER_RADIUS_BOTTOM_LEFT_KEY]}
                                    onValidate={this.validateBorderRadiusSizeValue}
                                    onBeforeValidate={this.validateNumberInput}
                                    onConfirm={this.onBtnsBottomLeftBorderRadiusChange}
                                    prefix="px"
                                />

                                <ColorPickerOption
                                    tooltipId="headerFontColorSettings"
                                    tooltip="Sets the font color for buttons in text chat"
                                    label="Font color"
                                    color={this.state[TEXT_CHAT_BUTTONS_FONT_COLOR_KEY]}
                                    horizontalPosition={ColorPickerHorizontalPosition.Right}
                                    onClose={this.onButtonsColorClose}
                                    onChange={this.onButtonsColorChange}
                                    containerRef={this.optionsContainerRef}
                                    verticalPosition={ColorPickerVerticalPosition.Smart}
                                />

                                <ColorPickerOption
                                    tooltipId="headerFontColorSettings"
                                    tooltip="Sets the font color for buttons in text chat (hovered state)"
                                    label="Font color (hovered)"
                                    color={this.state[TEXT_CHAT_BUTTONS_FONT_COLOR_HOVER_KEY]}
                                    horizontalPosition={ColorPickerHorizontalPosition.Right}
                                    onClose={this.onButtonsHoverColorClose}
                                    onChange={this.onButtonsHoverColorChange}
                                    containerRef={this.optionsContainerRef}
                                    verticalPosition={ColorPickerVerticalPosition.Smart}
                                />

                                <ColorPickerOption
                                    tooltipId="headerFontColorSettings"
                                    tooltip="Sets the font color for buttons in text chat (clicked state)"
                                    label="Font color (clicked)"
                                    color={this.state[TEXT_CHAT_BUTTONS_FONT_COLOR_ACTIVE_KEY]}
                                    horizontalPosition={ColorPickerHorizontalPosition.Right}
                                    onClose={this.onButtonsActiveColorClose}
                                    onChange={this.onButtonsActiveColorChange}
                                    containerRef={this.optionsContainerRef}
                                    verticalPosition={ColorPickerVerticalPosition.Smart}
                                />

                                <ColorPickerOption
                                    tooltipId="headerFontColorSettings"
                                    tooltip="Sets the background color for buttons in text chat"
                                    label="Background color"
                                    color={this.state[TEXT_CHAT_BUTTONS_BACKGROUND_COLOR_KEY]}
                                    horizontalPosition={ColorPickerHorizontalPosition.Right}
                                    onClose={this.onButtonsBackgroundColorClose}
                                    onChange={this.onButtonsBackgroundColorChange}
                                    containerRef={this.optionsContainerRef}
                                    verticalPosition={ColorPickerVerticalPosition.Smart}
                                />


                                <ColorPickerOption
                                    tooltipId="headerFontColorSettings"
                                    tooltip="Sets the background color for buttons in text chat (hovered state)"
                                    label="Background color (hovered)"
                                    color={this.state[TEXT_CHAT_BUTTONS_BACKGROUND_COLOR_HOVER_KEY]}
                                    horizontalPosition={ColorPickerHorizontalPosition.Right}
                                    onClose={this.onButtonsHoverBackgroundColorClose}
                                    onChange={this.onButtonsHoverBackgroundColorChange}
                                    containerRef={this.optionsContainerRef}
                                    verticalPosition={ColorPickerVerticalPosition.Smart}
                                />

                                <ColorPickerOption
                                    tooltipId="headerFontColorSettings"
                                    tooltip="Sets the background color for buttons in text chat (clicked state)"
                                    label="Background color (clicked)"
                                    color={this.state[TEXT_CHAT_BUTTONS_BACKGROUND_COLOR_ACTIVE_KEY]}
                                    horizontalPosition={ColorPickerHorizontalPosition.Right}
                                    onClose={this.onButtonsActiveBackgroundColorClose}
                                    onChange={this.onButtonsActiveBackgroundColorChange}
                                    containerRef={this.optionsContainerRef}
                                    verticalPosition={ColorPickerVerticalPosition.Smart}

                                />


                                <ColorPickerOption
                                    tooltipId="headerFontColorSettings"
                                    tooltip="Sets the border color for buttons in text chat"
                                    label="Border color"
                                    color={this.state[TEXT_CHAT_BUTTONS_BORDER_COLOR_KEY]}
                                    horizontalPosition={ColorPickerHorizontalPosition.Right}
                                    onClose={this.onButtonsBorderColorClose}
                                    onChange={this.onButtonsBorderColorChange}
                                    containerRef={this.optionsContainerRef}
                                    verticalPosition={ColorPickerVerticalPosition.Smart}
                                />

                                <ColorPickerOption
                                    tooltipId="headerFontColorSettings"
                                    tooltip="Sets the border color for buttons in text chat (hovered state)"
                                    label="Border color (hovered)"
                                    color={this.state[TEXT_CHAT_BUTTONS_BORDER_COLOR_HOVER_KEY]}
                                    horizontalPosition={ColorPickerHorizontalPosition.Right}
                                    onClose={this.onButtonsHoverBorderColorClose}
                                    onChange={this.onButtonsHoverBorderColorChange}
                                    containerRef={this.optionsContainerRef}
                                    verticalPosition={ColorPickerVerticalPosition.Smart}
                                />

                                <ColorPickerOption
                                    tooltipId="headerFontColorSettings"
                                    tooltip="Sets the border color for buttons in text chat (clicked state)"
                                    label="Border color (clicked)"
                                    color={this.state[TEXT_CHAT_BUTTONS_BORDER_COLOR_ACTIVE_KEY]}
                                    horizontalPosition={ColorPickerHorizontalPosition.Right}
                                    onClose={this.onButtonsActiveBorderColorClose}
                                    onChange={this.onButtonsActiveBorderColorChange}
                                    containerRef={this.optionsContainerRef}
                                    verticalPosition={ColorPickerVerticalPosition.Smart}
                                />


                                <SwitcherOption
                                    tooltipId="textChatOpenByDefaultSettings"
                                    tooltip="Add shadow for buttons in text chat"
                                    label="With shadow"
                                    onClick={this.setShadowForButtonsSettings}
                                    value={this.state[TEXT_CHAT_BUTTONS_HAS_SHADOW_KEY]}
                                />

                                <SwitcherOption
                                    tooltipId="textChatOpenByDefaultSettings"
                                    tooltip="Add shadow for buttons in text chat (hovered state)"
                                    label="With shadow (hovered)"
                                    onClick={this.setShadowForButtonsHoverSettings}
                                    value={this.state[TEXT_CHAT_BUTTONS_HAS_SHADOW_HOVER_KEY]}
                                />


                                <SwitcherOption
                                    tooltipId="textChatOpenByDefaultSettings"
                                    tooltip="Add shadow for buttons in text chat (clicked state)"
                                    label="With shadow (clicked)"
                                    onClick={this.onBtnHasShadowActiveChange}
                                    value={this.state[TEXT_CHAT_BUTTONS_HAS_SHADOW_ACTIVE_KEY]}
                                />



                                <ComboBoxOption
                                    tooltipId="btnsTextAlignment"
                                    tooltip="Set buttons text alignment in the text chat"
                                    label="Text alignment"
                                    values={alignOptions}
                                    value={this.state[TEXT_CHAT_BUTTONS_TEXT_ALIGNMENT_DEFAULT_KEY]}
                                    onChange={this.onTextAlignButtonsChange}
                                />

                                <ComboBoxOption
                                    tooltipId="btnsAlignment"
                                    tooltip="Set buttons alignment in the text chat"
                                    label="Buttons alignment"
                                    values={alignOptions}
                                    value={this.state[TEXT_CHAT_BUTTONS_ALIGNMENT_DEFAULT_KEY]}
                                    onChange={this.onBtnsAlignmentDefaultChange}
                                />

                                <ComboBoxOption
                                    tooltipId="btnsAlignmentFullScreen"
                                    tooltip="Set buttons alignment in the text chat in full screen mode (not available for preview)"
                                    label="Buttons alignment in full screen mode"
                                    values={alignOptions}
                                    value={this.state[TEXT_CHAT_BUTTONS_ALIGNMENT_FULL_SCREEN_KEY]}
                                    onChange={this.onBtnsAlignmentFullScreenChange}
                                    className={fullScreenModeEnabled ? '' : 'disabled'}
                                />

                                <InputOption
                                    tooltipId="btnGapSettings"
                                    tooltip="Sets the gap between buttons"
                                    label="Gap"
                                    value={this.state[TEXT_CHAT_BUTTONS_GAP_KEY]}
                                    onValidate={this.validateBtnsGapValue}
                                    onBeforeValidate={this.validateNumberInput}
                                    onConfirm={this.onBtnsGapChange}
                                    prefix="px"
                                />
                            </>}


                        <div className={`text-chat-options_group-name  `}>Footer</div>

                        <ComboBoxOption
                            tooltipId="footerLayoutName"
                            tooltip="Set layout type for chat's footer <br/><br/>Consider using a customized icon in the footer area when updating the layout."
                            label="Layout"
                            values={footerLayoutTypes}
                            value={this.state[TEXT_CHAT_FOOTER_LAYOUT_NAME_KEY]}
                            onChange={this.onFooterLayoutNameChange}
                        />

                        <ColorPickerOption
                            tooltipId="footerBgSettings"
                            tooltip="Sets the background color for chat's footer"
                            label="Background color"
                            color={this.state[TEXT_CHAT_FOOTER_BACKGROUND_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onFooterBackgroundColorClose}
                            onChange={this.onFooterBackgroundColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <InputOption
                            tooltipId="footerHeightSettings"
                            tooltip="Sets the footer height (in a range 60px - 100px)"
                            label="Height"
                            value={this.state[TEXT_CHAT_FOOTER_HEIGHT_KEY]}
                            onValidate={this.validateFooterHeightValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onFooterHeightChange}
                            prefix="px"
                        />

                        <SwitcherOption
                            tooltipId="textChatFooterWithBottomGradientSettings"
                            tooltip="Add smoth gradient for messages that go outside of the scrolling area"
                            onClick={this.setFooterWithTopGradientSettings}
                            value={this.state[TEXT_CHAT_FOOTER_WITH_TOP_GRADIENT_KEY]}
                            label="With gradient on top border"
                        />


                        <InputOption
                            tooltipId="footerTopPaddingSettings"
                            tooltip="Sets the top padding (in a range 0px - 40px)"
                            label="Top padding"
                            value={this.state[TEXT_CHAT_FOOTER_PADDING_TOP_KEY]}
                            onValidate={this.validateFooterPaddingValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onFooterPaddingTopHeightChange}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="footerRightPaddingSettings"
                            tooltip="Sets the right padding (in a range 0px - 40px)"
                            label="Right padding"
                            value={this.state[TEXT_CHAT_FOOTER_PADDING_RIGHT_KEY]}
                            onValidate={this.validateFooterPaddingValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onFooterPaddingRightHeightChange}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="footerBottomPaddingSettings"
                            tooltip="Sets the bottom padding (in a range 0px - 40px)"
                            label="Bottom padding"
                            value={this.state[TEXT_CHAT_FOOTER_PADDING_BOTTOM_KEY]}
                            onValidate={this.validateFooterPaddingValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onFooterPaddingBottomHeightChange}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="footerLeftPaddingSettings"
                            tooltip="Sets the left padding (in a range 0px - 40px)"
                            label="Left padding"
                            value={this.state[TEXT_CHAT_FOOTER_PADDING_LEFT_KEY]}
                            onValidate={this.validateFooterPaddingValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onFooterPaddingLeftHeightChange}
                            prefix="px"
                        />

                        <SvgIconOption
                            value={this.state[TEXT_CHAT_SEND_ICON_KEY]}
                            tooltipId="customSendIconSettings"
                            tooltip="Sets the custom icon for the send icon"
                            label="Send icon"
                            onReset={this.onSendIconSvgReset}
                            onChange={this.onSendIconSvgChange}
                            iconHeight={28}
                            iconWidth={44}
                        />

                        <SwitcherOption
                            label="Allows user to clear messages in chat"
                            value={isClearIconVisible}
                            onClick={this.setClearIconVisibilitySettings}
                            tooltip="Enables user to clear messages in the chat"
                            tooltipId="clearIconEnabledSettings"
                        />

                        <ColorPickerOption
                            className={isClearIconVisible ? '' : 'disabled'}
                            tooltipId="headerFontColorSettings"
                            tooltip="Sets the background color for clear icon"
                            label="Clear icon color"
                            color={this.state[TEXT_CHAT_CLEAR_ICON_FILL_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onClearIconBackgroundColorClose}
                            onChange={this.onClearIconBackgroundColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <ColorPickerOption
                            className={isClearIconVisible ? '' : 'disabled'}
                            tooltipId="headerFontColorSettings"
                            tooltip="Sets the background color for clear icon in active state"
                            label="Clear icon color (hovered)"
                            color={this.state[TEXT_CHAT_CLEAR_ICON_HOVER_FILL_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onClearIconOnHoverBackgroundColorClose}
                            onChange={this.onClearIconOnHoverBackgroundColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />


                        <div className={`text-chat-options_group-name  `}>Chat input</div>

                        <InputOption
                            tooltipId="headerLabelSettings"
                            tooltip="Sets the placeholder text for the chat input box"
                            label="Placeholder"
                            value={this.state[TEXT_CHAT_TEXTAREA_PLACEHOLDER_KEY] || ''}
                            onValidate={this.validatePlaceholder}
                            onConfirm={this.onSaveTextarePlaceholder}
                        />

                        <ComboBoxOption
                            tooltipId="chatInputType"
                            tooltip="Enable / disable multi-line input in text chat"
                            label="Type"
                            values={chatInputTypes}
                            value={this.state[TEXT_CHAT_TEXTAREA_FIELD_TYPE_KEY]}
                            onChange={this.onTextInputTypeChange}
                        />

                        <InputOption
                            className={this.state[TEXT_CHAT_TEXTAREA_FIELD_TYPE_KEY] !== 'multi-line' ? 'disabled' : ''}
                            tooltipId="responseFontSizeSettings"
                            tooltip="Sets the maximum number of lines after which a scrollbar will appear in the textarea, if multi-line mode is enabled"
                            label="Max. lines count"
                            value={this.state[TEXT_CHAT_TEXTAREA_MAX_LINES_COUNT_KEY]}
                            onValidate={this.validateMaxLinesCountForTextarea}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onTextareaMaxLinesCountChange}
                            width="164px"
                        />

                        <InputOption
                            tooltipId="responseFontSizeSettings"
                            tooltip="Sets the font size for response text bubbles (in a range 10px - 22px)"
                            label="Font size"
                            value={this.state[TEXT_CHAT_TEXTAREA_FONT_SIZE_KEY]}
                            onValidate={this.validateFontSizeValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onTextareaFontSizeChange}
                            prefix="px"
                        />

                        <ColorPickerOption
                            tooltipId="headerFontColorSettings"
                            tooltip="Sets the font color for text area"
                            label="Font color"
                            color={this.state[TEXT_CHAT_TEXTAREA_FONT_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onTextareaColorClose}
                            onChange={this.onTextareaColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <ColorPickerOption
                            tooltipId="headerFontColorSettings"
                            tooltip="Sets the placeholder font color for the text area. This color is also applied to the send icon when it is inactive (i.e., when there is no text in the input field)"
                            label={<span>Placeholder font color<i style={{ position: 'relative', top: '2px', left: '4px' }} className="icon icon-alan-info-sign" /></span> as any}
                            color={this.state[TEXT_CHAT_TEXTAREA_PLACEHOLDER_FONT_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onTextareaPlaceholderColorClose}
                            onChange={this.onTextareaPlaceholderColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <ColorPickerOption
                            tooltipId="headerFontColorSettings"
                            tooltip="Sets the background color for text area"
                            label="Background color"
                            disableAlpha={true}
                            color={this.state[TEXT_CHAT_TEXTAREA_BACKGROUND_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onTextareaBackgroundColorClose}
                            onChange={this.onTextareaBackgroundColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <ColorPickerOption
                            tooltipId="headerFontColorSettings"
                            tooltip="Sets the border color for text area"
                            label="Border color"
                            color={this.state[TEXT_CHAT_TEXTAREA_BORDER_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onTextareaBorderColorClose}
                            onChange={this.onTextareaBorderColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />


                        {platform === 'web' &&
                            <SwitcherOption
                                tooltipId="textChatOpenByDefaultSettings"
                                tooltip="Add shadow for text area"
                                onClick={this.setShadowForTextareaSettings}
                                value={this.state[TEXT_CHAT_TEXTAREA_HAS_SHADOW_KEY]}
                                label="With shadow"
                            />
                        }

                        <SvgIconOption
                            value={this.state[TEXT_CHAT_MIC_ICON_KEY]}
                            tooltipId="customMicIconSettings"
                            tooltip="Sets the custom icon for the microphone icon"
                            label="Microphone icon"
                            onReset={this.onMicIconSvgReset}
                            onChange={this.onMicIconSvgChange}
                            iconHeight={28}
                            iconWidth={28}
                        />

                        <ColorPickerOption
                            tooltipId="headerFontColorSettings"
                            tooltip="Sets the background color for send and microphone icons in the chat input box"
                            label="Send and mic. icons color"
                            color={this.state[TEXT_CHAT_TEXTAREA_ICONS_DEFAULT_FILL_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onIconsBackgroundColorClose}
                            onChange={this.onIconsBackgroundColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <ColorPickerOption
                            tooltipId="headerFontColorSettings"
                            tooltip="Sets the background color for send and microphone icons in the chat input box"
                            label="Send and mic. icons color (hovered)"
                            color={this.state[TEXT_CHAT_TEXTAREA_ICONS_HOVER_FILL_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onIconsOnHoverBackgroundColorClose}
                            onChange={this.onIconsOnHoverBackgroundColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <InputOption
                            tooltipId="textareaTopPaddingSettings"
                            tooltip="Sets the top padding (in a range 0px - 40px)"
                            label="Top padding"
                            value={this.state[TEXT_CHAT_TEXTAREA_PADDING_TOP_KEY]}
                            onValidate={this.validateTextareaPaddingValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onTextareaPaddingTopHeightChange}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="textareaRightPaddingSettings"
                            tooltip="Sets the right padding (0px - 40px). If the padding exceeds the border-radius of the right corners, it will be applied as specified. Otherwise, the padding will match the larger of the top-right or bottom-right border-radius values."
                            label="Right padding"
                            value={this.state[TEXT_CHAT_TEXTAREA_PADDING_RIGHT_KEY]}
                            onValidate={this.validateTextareaPaddingValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onTextareaPaddingRightHeightChange}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="textareaBottomPaddingSettings"
                            tooltip="Sets the bottom padding (in a range 0px - 40px)"
                            label="Bottom padding"
                            value={this.state[TEXT_CHAT_TEXTAREA_PADDING_BOTTOM_KEY]}
                            onValidate={this.validateTextareaPaddingValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onTextareaPaddingBottomHeightChange}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="textareaLeftPaddingSettings"
                            tooltip="Sets the left padding (in a range 0px - 40px)"
                            label="Left padding"
                            value={this.state[TEXT_CHAT_TEXTAREA_PADDING_LEFT_KEY]}
                            onValidate={this.validateTextareaPaddingValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onTextareaPaddingLeftHeightChange}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="requestFontSizeSettings"
                            tooltip="Sets the border radius for the top left textarea corner (in a range 0px - 30px)"
                            label="Top left border radius"
                            onValidate={this.validateBorderRadiusSizeValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onTextareaTopLeftBorderRadiusChange}
                            value={this.state[TEXT_CHAT_TEXTAREA_BORDER_RADIUS_TOP_LEFT_KEY]}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="requestFontSizeSettings"
                            tooltip="Sets the border radius for the top right textarea corner (in a range 0px - 30px)"
                            label="Top right border radius"
                            value={this.state[TEXT_CHAT_TEXTAREA_BORDER_RADIUS_TOP_RIGHT_KEY]}
                            onValidate={this.validateBorderRadiusSizeValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onTextareaTopRightBorderRadiusChange}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="requestFontSizeSettings"
                            tooltip="Sets the border radius for the bottom right textarea corner (in a range 0px - 30px)"
                            label="Bottom right border radius"
                            value={this.state[TEXT_CHAT_TEXTAREA_BORDER_RADIUS_BOTTOM_RIGHT_KEY]}
                            onValidate={this.validateBorderRadiusSizeValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onTextareaBottomRightBorderRadiusChange}
                            prefix="px"
                        />

                        <InputOption
                            tooltipId="requestFontSizeSettings"
                            tooltip="Sets the border radius for the bottom left textarea corner (in a range 0px - 30px)"
                            label="Bottom left border radius"
                            value={this.state[TEXT_CHAT_TEXTAREA_BORDER_RADIUS_BOTTOM_LEFT_KEY]}
                            onValidate={this.validateBorderRadiusSizeValue}
                            onBeforeValidate={this.validateNumberInput}
                            onConfirm={this.onTextareaBottomLeftBorderRadiusChange}
                            prefix="px"
                        />



                        <div className={`text-chat-options_group-name  `}>Notifications bubble</div>


                        <ColorPickerOption
                            tooltipId="headerFontColorSettings"
                            tooltip="Sets the font color for notifications bubble"
                            label="Font color"
                            color={this.state[TEXT_CHAT_NOTIFICATIONS_BUBBLE_FONT_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onNotificationColorClose}
                            onChange={this.onNotificationColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />

                        <ColorPickerOption
                            tooltipId="headerFontColorSettings"
                            tooltip="Sets the background color for notifications bubble"
                            label="BackgroundFont color"
                            color={this.state[TEXT_CHAT_NOTIFICATIONS_BUBBLE_BACKGROUND_COLOR_KEY]}
                            horizontalPosition={ColorPickerHorizontalPosition.Right}
                            onClose={this.onNotificationBackgroundColorClose}
                            onChange={this.onNotificationBackgroundColorChange}
                            containerRef={this.optionsContainerRef}
                            verticalPosition={ColorPickerVerticalPosition.Smart}
                        />
                    </div>
                </div>
                <div className="alan-button-options_table_column-sep" />
                <div className="alan-button-options_table_column">
                    <div className="text-chat-options_preview-area">
                        {textChatEnabled ?
                            <>
                                {previewMode === TextChatPreviewModeOptions.Btn ?
                                    <NotificationsBtnPreview
                                        platform={platform}
                                        btnOptions={btnOptions}
                                        notificationsBubbleFontColor={this.state[TEXT_CHAT_NOTIFICATIONS_BUBBLE_FONT_COLOR_KEY]}
                                        notificationsBubbleBackgroundColor={this.state[TEXT_CHAT_NOTIFICATIONS_BUBBLE_BACKGROUND_COLOR_KEY]}
                                    /> :
                                    <TextChatPreview platform={platform} {...this.state} />}
                                <div className="text-chat-options_preview-area-dots">
                                    <div className={`text-chat-options_preview-area-dot ${previewMode === TextChatPreviewModeOptions.Chat ? 'selected' : ''}`} onClick={() => {
                                        this.setState({ previewMode: TextChatPreviewModeOptions.Chat });
                                    }}></div>
                                    <div className={`text-chat-options_preview-area-dot ${previewMode === TextChatPreviewModeOptions.Btn ? 'selected' : ''}`} onClick={() => {
                                        this.setState({ previewMode: TextChatPreviewModeOptions.Btn });
                                    }}></div>
                                </div>
                            </> :
                            <div className="text-chat-preview__chat-disabled">
                                Text chat is disabled
                            </div>
                        }
                    </div>

                </div>
            </div>
        </div>;
    }
}

function mapStateToProps({ projectsInfo, user }: IStore) {
    return {
        isProjectOptionsSaving: projectsInfo.isProjectOptionsSaving,
        email: user.email
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setProjectOptions: (param) => asyncDispatch(actions.setProjectOptions, dispatch, param),
        getButtonOptions: (param) => asyncDispatch(actions.getButtonOptions, dispatch, param),
    };
}

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(TextChatOptions);

